// cspell:disable
// Use backticks instead of quotes to avoid having to escape apostrophes and quotes in the strings
/* oxlint quotes: ["error", "backtick"] */
export const Strings = {
    ACCOUNT: ``,
    ACCOUNT_PROFILE: `Profilo account`,
    ACCOUNT_CREATED: ``,
    ACCOUNT_VERIFIED: ``,
    LOG_IN_TO_START_ORDERING: ``,
    VERIFY_LINK_INVALID: ``,
    VERIFY_LINK_INVALID_LOG_IN: ``,
    ORDERS: ``,
    PROFILE: ``,
    PROFILE_UPDATED: ``,
    PAYMENT_METHODS: ``,
    PERSONAL_DETAILS: ``,
    SAVE_CHANGES: ``,
    ADD_CARD: ``,
    CARD_NICKNAME: ``,
    NO_SAVED_CARDS: ``,
    QR_CODE: ``,
    REFRESH_QR_CODE: ``,
    QR_CODE_SCAN_TO_PAY: ``,
    ADA_TOGGLE_ON: `Tocchi per attivare l'altezza schermo ridotta`,
    ADA_TOGGLE_OFF: `Tocchi per disattivare l'altezza schermo ridotta`,
    ADD: `Aggiungi`,
    ADD_DONATION: `Aggiungi donazione`,
    ADD_FUNDS: `Aggiungi fondi qui`,
    ADD_TIP: `Aggiungi una mancia`,
    ADD_TO_FAVORITES_WEB: ``,
    ADD_TO_ORDER: `Aggiungi all'ordine`,
    ADD_NEW: `Aggiungi nuovo`,
    ADDED: `Aggiunto`,
    ADDED_TO_FAVORITES_WEB: ``,
    ADDED_TO_ORDER: `Aggiunto all'ordine`,
    ADDON_TEXTFIELD_PLACEHOLDER: `Scriva la sua scelta.`,
    ADDRESS_CITY: `Città`,
    ADDRESS_LINE_1: `Indirizzo`,
    ADDRESS_LINE_2: `Interno, piano, suite, edificio, azienda (facoltativo)`,
    ADDRESS_POSTAL_CODE: `Codice postale`,
    ALCOHOL_VERIFICATION: `Verifica dell'età per alcolici`,
    ALREADY_HAVE_AN_ACCOUNT: ``,
    ALSO_CONSIDER: `Potrebbe interessarle anche...`,
    APPLIED_STORED_VALUE_CARDS: `Carte regalo`,
    ASAP: `Il prima possibile`,
    AT_LEAST_X: `almeno {{$1: number}}`,
    BACK: `Indietro`,
    BACK_TO_MENU: `Torna al menu`,
    BACK_TO_MENU_FROM_LOYALTY: `Torna al menu`,
    BACK_TO_CART: `Torna al carrello`,
    BACK_TO_PAYMENT_OPTIONS: `Torna alle opzioni di pagamento`,
    BACK_TO_PAYMENT_OPTIONS_FROM_LOYALTY: `Torna alle opzioni di pagamento`,
    BAD_ACCESS_CODE: `Codice di accesso errato`,
    BALANCE: `Saldo`,
    BAG_OPT_IN_PROMPT: `Desidera aggiungere una borsa da asporto al suo ordine?`,
    BAG_OPT_IN_TITLE: `Aggiungere una borsa?`,
    BAG_OPT_IN: `Sì, desidero una borsa`,
    BAG_OPT_OUT: `No, grazie`,
    BLOCKED_WORD_WARNING: `Rimuova le parole non consentite`,
    CALORIES: `Calorie`,
    CANCEL: `Annulla`,
    CANCEL_CHECKOUT: `Annulla`,
    CASH: `Cassiere`,
    CARD_ENTRY_APM: `APM`,
    CARD_ENTRY_APPLE_PAY: `Apple Pay`,
    CARD_ENTRY_CARD_ON_FILE: `Carta registrata`,
    CARD_ENTRY_CHIP: `EMV`,
    CARD_ENTRY_CONTACTLESS: `Contactless`,
    CARD_ENTRY_GOOGLE_PAY: `Google Pay`,
    CARD_ENTRY_MANUALLY_ENTERED: `Inserita manualmente`,
    CARD_ENTRY_PROVIDED_EXTERNALLY: `Fornita esternamente`,
    CARD_ENTRY_SCAN: `Scansiona`,
    CARD_ENTRY_SWIPE: `Striscia`,
    CARD_ENTRY_UNKNOWN: `Sconosciuto`,
    CARD_EXPIRED: `La sua carta è scaduta`,
    CARD_EXPIRING: `La sua carta sta per scadere`,
    CARD_ENDING_IN: ``,
    CARD_EXPIRES_ON: ``,
    CARD_EXPIRES_THIS_MONTH: ``,
    CARD_EXPIRED_LABEL: ``,
    REMOVE_SAVED_CARD_DESCRIPTION: ``,
    CARD_RENAMED: ``,
    REMOVE_SAVED_CARD: ``,
    REMOVE_SAVED_CARD_TITLE: ``,
    RENAME_CARD: ``,
    SHOW_QR_CODE: ``,
    CART: `Carrello`,
    CART_LABEL: `Vai al carrello con {{$1: number}} articoli per {{$2: price}}`,
    CART_TITLE: ``,
    CHANGE_ITEM: `Cambia articolo`,
    CHANGE_PASSWORD: `Cambia password`,
    CHANGE_PASSWORD_SUCCESS: `La sua password è stata aggiornata.`,
    CHARS_LEFT: `{{$1: number}} caratteri rimanenti`,
    CHECK_AMOUNT: `Verifica dell'importo...`,
    CHECKOUT: `Paga`,
    CHECKOUT_STEP_CART: `Carrello`,
    CHECKOUT_STEP_PAYMENT_OPTIONS: `Pagamento`,
    CHECKOUT_STEP_PAYING: `Pagamento in corso`,
    CHECKOUT_STEP_DONE: `Fatto`,
    CHECKOUT_WITH_FORCED_MENU: `Non è possibile pagare durante la visualizzazione dell'anteprima del menu. Il pagamento è disponibile solo durante la visualizzazione del menu "Mostrato attualmente".`,
    CHECK_YOUR_EMAIL: ``,
    CHOOSE_OPTION: `Scelga un'opzione`,
    CHOOSE_TIME_SLOT: `Scelga un orario:`,
    CLEAR_ALL: `Cancella tutto`,
    CLEARING_SESSION: `Preparazione del chiosco per il prossimo cliente...`,
    CLOSE: `Chiudi`,
    CLOSED_SCREEN_MESSAGE: `Siamo spiacenti, siamo chiusi o non accettiamo ordini mobili.`,
    CONFIRM: `Conferma`,
    CONFIRM_ADDRESS: `Conferma indirizzo`,
    CONFIRM_DISCARD: `Eliminare l'articolo?`,
    CONFIRM_DISCARD_CHANGES: `È sicuro di voler eliminare le sue modifiche?`,
    CONFIRM_YOUR_ITEM: `Confermi il suo articolo`,
    CONFIRM_QUIT: `È sicuro di voler uscire?`,
    CONFIRM_REFUND_AMOUNT: `È sicuro di voler rimborsare {{$1: dollar amount}} di questa transazione?`,
    CONFIRMING_YOUR_CARD: `Conferma della sua carta in corso...`,
    CONTINUE: `Continua`,
    CONTINUE_AS_GUEST: `Continua come ospite`,
    COULD_WE_INTEREST: `Potrebbe interessarle...`,
    COMP_CARD: `Carta omaggio`,
    COMP_CARD_SCAN: `Scansiona carta omaggio`,
    COMP_CARD_SCAN_FAILED_TITLE: `Scansione carta omaggio non riuscita`,
    COMP_CARD_SCAN_FAILED_MESSAGE: `Si è verificato un errore durante la scansione della carta omaggio. Riprovi.`,
    COMP_CARD_APPLYING_TITLE: `Applicazione carta omaggio`,
    COMP_CARD_APPLYING_ERROR_TITLE: `Errore nell'applicazione della carta omaggio`,
    COMP_CARD_APPLYING_ERROR_MESSAGE: `Si è verificato un errore durante l'applicazione della carta omaggio. Riprovi.`,
    COMP_CARD_ENTERING_NUMBER_ERROR_REQUIRED: `Inserisca il numero della carta omaggio`,
    COMP_CARD_ENTERING_NUMBER_ERROR_INVALID: `Inserisca un numero valido della carta omaggio`,
    COMP_CARD_ENTERING_NUMBER_ERROR_LENGTH: `Inserisca un numero valido della carta omaggio`,
    COMP_CARD_ENTERING_PIN_ERROR_REQUIRED: `Inserisca il PIN della carta omaggio`,
    COMP_CARD_ENTERING_PIN_ERROR_INVALID: `Inserisca un PIN valido della carta omaggio`,
    COMP_CARD_ENTERING_PIN_ERROR_LENGTH: `Inserisca un PIN valido della carta omaggio`,
    COMP_CARD_ENTERING_NUMBER_HINT: `Inserisca il numero della carta omaggio. I numeri possono avere {{$1: number}} cifre.`,
    COMP_CARD_ENTERING_PIN_HINT: `Inserisca il PIN della carta omaggio. I numeri possono avere {{$1: length}} cifre.`,
    COMP_CARD_ERROR_REMOVING: `Si è verificato un errore durante la rimozione della carta omaggio. Riprovi.`,
    'bottom-bar.storm-toggle.on': `Tocchi per attivare la navigazione Storm`,
    'bottom-bar.storm-toggle.off': `Tocchi per disattivare la navigazione Storm`,
    'campus-card.label': `Tessera universitaria`,
    'campus-card.payment-line-label': ``,
    'campus-card.payment-option-label': `Tocchi per pagare con una tessera universitaria`,
    'campus-card.scan': `Scansioni la sua tessera universitaria`,
    'campus-card.scan-failed.title': `Scansione tessera universitaria non riuscita`,
    'campus-card.scan-failed.message': `Si è verificato un errore durante la scansione della tessera universitaria. Riprovi.`,
    'campus-card.enter-number': `Inserisca il numero della sua tessera universitaria`,
    'campus-card.enter-pin': `Inserisca il PIN della sua tessera universitaria`,
    'campus-card.applying.title': `Applicazione tessera universitaria`,
    'campus-card.applying.error.title': `Errore nell'applicazione della tessera universitaria`,
    'campus-card.applying.error.message': `Si è verificato un errore durante l'applicazione della tessera universitaria. Riprovi.`,
    'campus-card.entering-number.error.required': `Inserisca un numero di tessera universitaria.`,
    'campus-card.entering-number.error.invalid': `Inserisca un numero di tessera universitaria valido.`,
    'campus-card.entering-number.error.length': `Inserisca un numero di tessera universitaria valido.`,
    'campus-card.entering-number.hint': `Inserisca il numero della sua tessera universitaria. I numeri possono avere {{$1: number}} cifre.`,
    'campus-card.entering-pin.error.required': `Inserisca il PIN della tessera universitaria`,
    'campus-card.entering-pin.error.invalid': `Inserisca un PIN valido della tessera universitaria`,
    'campus-card.entering-pin.error.length': `Inserisca un PIN valido della tessera universitaria`,
    'campus-card.entering-pin.hint': `Inserisca il PIN della sua tessera universitaria. I numeri possono avere {{$1: length}} cifre.`,
    'campus-card.error-removing': `Si è verificato un errore durante la rimozione della tessera universitaria. Riprovi.`,
    'campus-card.no-balance.title': `Nessun saldo disponibile`,
    'campus-card.no-balance.message': `Non c'è saldo disponibile su questa tessera universitaria.`,
    'campus-card.add-another': `Aggiungi un'altra`,
    'campus-card.remove': `Rimuovi tessera universitaria`,
    'campus-card.select-account.title': `Selezioni un account`,
    'campus-card.select-account.loading': `Caricamento account...`,
    'campus-card.select-account.error.title': `Impossibile caricare gli account`,
    'campus-card.select-account.error.message': `Non è stato possibile caricare i suoi account. Riprovi.`,
    'campus-card.select-account.column.account': `Account`,
    'campus-card.select-account.column.balance': `Saldo attuale`,
    'campus-card.select-account.error.toast-title': `Errore`,
    'campus-card.select-account.error.toast-message': `Convalida non riuscita. Riprovi.`,
    'campus-card.swipe': `Strisci la sua tessera universitaria per pagare`,
    COUPON: `Coupon`,
    COUPON_ALREADY_USED: `Codice coupon già utilizzato.`,
    COUPON_MIN_SPEND_NOT_MET: `Il codice coupon inserito non soddisfa il requisito di spesa minima.`,
    COUPON_NOT_FOUND: `Codice coupon non trovato.`,
    COUPON_NOT_ACCEPTED: `Il codice coupon inserito non è stato accettato.`,
    COUPON_APPLYING: `Applicazione coupon`,
    COUPON_APPLYING_ERROR_TITLE: `Errore nell'applicazione del coupon`,
    COUPON_APPLYING_ERROR_MESSAGE: `Si è verificato un errore durante l'applicazione del coupon. Riprovi.`,
    COUPON_ORDER_REQUIREMENTS_NOT_MET: `Il codice coupon inserito non soddisfa i requisiti dell'ordine.`,
    COUPON_SCANNING_ERROR_TITLE: `Errore nella scansione del coupon`,
    COUPON_SCANNING_ERROR_MESSAGE: `Si è verificato un errore durante la scansione del coupon. Riprovi.`,
    COUPON_ENTERING_ERROR_LENGTH: `Inserisca un codice coupon.`,
    COUPON_ENTERING_ERROR_INVALID: `Inserisca un codice coupon valido.`,
    COUPON_ERROR_REMOVING: `Si è verificato un errore durante la rimozione del coupon. Riprovi. Se il problema persiste, contatti un membro del personale.`,
    CREATE_A_NEW_ACCOUNT: `Crea un nuovo account`,
    CREATE_ACCOUNT: `Crea account`,
    CREATE_ACCOUNT_TERMS_LINE: `Creando un account, lei accetta i`,
    CREDIT_CARD: `Carta di credito`,
    CREDIT_CARD_NUMBER: `Numero della carta`,
    CURBSIDE: `Al marciapiede`,
    CURRENT_PASSWORD: `Password attuale`,
    CUSTOM_TIP: `Personalizzata`,
    CUSTOM_TIP_INVALID: `Inserisca un importo della mancia valido.`,
    CUSTOM_TIP_HINT: `Inserisca l'importo della sua mancia. Massimo: {{$1: number}}`,
    CUSTOM_DONATION: `Donazione personalizzata`,
    CUSTOMER_CARDS: `Usa una carta salvata`,
    CUSTOMER_ACCOUNT_BUTTON_LOG_IN: `Accedi`,
    CUSTOMER_ACCOUNT_BUTTON_LOG_IN_TOP_BAR: ``,
    CUSTOMER_ACCOUNT_BUTTON_LOGGED_IN: `Il suo account`,
    CUSTOMIZE: `Personalizza`,
    DEBIT: `Debito`,
    DEBIT_CREDIT_CARD: `Carta di debito/credito`,
    DEMO_PAY: `Demo: Paga`,
    DELIVERY: `Consegna a domicilio`,
    DELIVERY_ADDRESS: `Indirizzo di consegna`,
    DELIVERY_INSTRUCTIONS: ``,
    DESELECTED_MOD_PREFIX: `Rimuovi {{$1: mod name}}`,
    DINE_IN: `Consuma qui`,
    DISCLAIMER_EMAIL: `L'uso dell'indirizzo email è soggetto ai Termini di servizio.`,
    DISCLAIMER_PHONE: `L'uso del numero di telefono è soggetto ai Termini di servizio.`,
    DISCLAIMER_PHONE_LINK: `TERMINI DI SERVIZIO:`,
    DISCLAIMER_PHONE_DESCRIPTION: `PER L'USO DEL NUMERO DI TELEFONO`,
    DISCLAIMER_NAME: `Il suo nome verrà utilizzato per confermare il suo ordine e facilitare il ritiro dell'ordine nell'area designata.`,
    DISCOUNTS: `Sconti`,
    DISCOUNTS_WILL_BE_APPLIED_AT_CHECKOUT: `Gli sconti verranno applicati al pagamento`,
    DISCOUNT_WILL_BE_APPLIED_AT_CHECKOUT: `Lo sconto verrà applicato al pagamento`,
    DONATION: `Donazione`,
    DONATION_APPLYING: `Applicazione donazione...`,
    DONATION_APPLY_ERROR_TITLE: `Errore nell'applicazione della donazione`,
    DONATION_APPLY_ERROR_MESSAGE: `Si è verificato un errore durante l'applicazione della sua donazione. Riprovi.`,
    DONATION_FAILED: `Donazione non riuscita. Riprovi.`,
    DONATION_ROUND_UP_TITLE: `Desidera arrotondare il suo totale?`,
    DONATION_ROUND_UP_TO: `Arrotonda a {{$1: amount}}`,
    DONATION_ROUND_UP_SUBTITLE: `Desidera arrotondare il suo totale al dollaro intero più vicino?`,
    DONATION_ROUND_UP_ACCEPT: `Sì, arrotonda`,
    DONATION_ROUND_UP_REJECT: `No, grazie`,
    DONATION_REMOVE: `Rimuovi donazione`,
    DONE: `Fatto`,
    DONT_INCLUDE_UTENSILS: `Non includere le posate`,
    EBT: `SNAP EBT`,
    EBT_REFUND: `Rimborso EBT`,
    EBT_CHOICE_DIALOG_TITLE: `Quale metodo EBT desidera usare?`,
    EBT_CHOICE_CASH_BENEFIT: `Beneficio in contanti`,
    EBT_CHOICE_FOOD_STAMPS: `Buoni pasto`,
    EBT_CARD_SUBTITLE: `Strisci la sua carta EBT sul terminale delle carte`,
    EDIT: `Modifica`,
    EDIT_ORDER: `Modifica ordine`,
    EDIT_TIP: `Modifica mancia`,
    SAVE_ORDER: `Salva ordine`,
    SAVE_BUTTON: ``,
    EMAIL_ADDRESS: `Indirizzo email`,
    EMAIL_RECEIPT: `Ricevuta via email`,
    EMAIL_REQUIRED_FOR_RECEIPT: `È richiesta un'email per la sua ricevuta.`,
    EMAIL_RECEIPT_SEND_FAILED: `Impossibile inviare la ricevuta. Riprovi.`,
    EMAIL_RECEIPT_SEND_SUCCESS: `Ricevuta inviata con successo.`,
    ENTER_ACCESS_CODE: `Inserisca il codice di accesso:`,
    ENTER_EMAIL_CUSTOMER_IDENTIFIER: `Inserisca la sua email`,
    ENTER_GIFT_CARD_BARCODE_FALLBACK: `Non riesce a scansionare? Inserisca il numero della sua carta.`,
    ENTER_PHONE_CONSENT: `Acconsento a ricevere materiali di marketing via SMS.`,
    ENTER_PHONE_CUSTOMER_IDENTIFIER: `Inserisca il suo numero di telefono`,
    ENTER_PHONE_CUSTOMER_IDENTIFIER_WITH_NAME: `Ciao {{$1 guest name}}, inserisca il suo numero di telefono`,
    ENTER_PHONE_LOYALTY: `Inserisca il suo numero di cellulare`,
    ENTER_PHONE_RECEIPT: `Inserisca il suo numero di cellulare per ricevere una ricevuta`,
    ENTER_PHONE_TEXT_WHEN_READY: `Inserisca il suo numero di telefono per ricevere un messaggio quando il suo ordine è pronto!`,
    ENTER_VEHICLE_DESCRIPTION: `Inserisca i dettagli del suo veicolo così possiamo portarle il suo ordine:`,
    ENTER_YOUR_COUPON_CODE: `Inserisca il suo codice coupon`,
    ENTER_YOUR_COMP_CARD_NUMBER: `Inserisca il numero della sua carta omaggio`,
    ENTER_YOUR_COMP_CARD_PIN: `Inserisca il PIN della sua carta omaggio`,
    ENTER_YOUR_GIFT_CARD_NUMBER: `Inserisca il numero della sua carta regalo`,
    ENTER_YOUR_GIFT_CARD_PIN: `Inserisca il PIN della sua carta regalo`,
    ENTER_YOUR_EMAIL: `Inserisca la sua email:`,
    ENTER_YOUR_EMAIL_VALIDATION_FAILED: `Email non valida. La preghiamo di riprovare.`,
    ENTER_YOUR_FIRST_NAME: `Inserisca il suo nome:`,
    ENTER_YOUR_LAST_NAME: `Inserisca l'iniziale del suo cognome:`,
    ENTER_YOUR_NAME: `Inserisca il suo nome:`,
    ENTER_YOUR_NAME_VALIDATION_FAILED: `Nome non valido. La preghiamo di riprovare.`,
    ENTER_YOUR_NAME_VALIDATION_LENGTH_FAILED: `La preghiamo di inserire un nome.`,
    ENTER_YOUR_LAST_NAME_VALIDATION_LENGTH_FAILED: `È consentita una sola lettera. La preghiamo di riprovare.`,
    ENTER_YOUR_NAME_VALIDATION_FORMAT_FAILED: `Il nome deve contenere solo lettere. La preghiamo di riprovare.`,
    ENTER_YOUR_NAME_VALIDATION_PROFANITY_FAILED: `Il nome contiene parole inappropriate. La preghiamo di riprovare.`,
    ERROR: `Ops!`,
    ERROR_ADDING_ITEM: `Si è verificato un errore durante l'aggiunta dell'articolo al suo carrello. La preghiamo di riprovare. Se il problema persiste, chieda assistenza al membro del personale più vicino.`,
    ERROR_EDITING_ITEM: `Si è verificato un errore durante la modifica dell'articolo nel suo carrello. La preghiamo di riprovare. Se il problema persiste, chieda assistenza al membro del personale più vicino.`,
    ERROR_AMOUNT_EXCEEDS_BALANCE: `L'importo supera il saldo della carta.`,
    ERROR_CARD_CONFIRMATION: `Ci dispiace! Non è stato possibile confermare la carta. La preghiamo di riprovare.`,
    ERROR_CARD_DECLINED: `Non è stato possibile addebitare l'importo sulla carta indicata. La preghiamo di riprovare.`,
    ERROR_CARD_INACTIVE: `Ci dispiace, questa tessera studenti non è attiva.`,
    ERROR_CARD_NOT_FOUND: `Ci dispiace! Non siamo riusciti a trovare questa carta. La preghiamo di riprovare.`,
    ERROR_CARD_NUMBER_LENGTH: `Il numero della carta non ha la lunghezza corretta.`,
    ERROR_CARD_RESTRICTED_TIME: `Ci dispiace, questa carta non può essere utilizzata in questo momento.`,
    ERROR_CARD_SCHEME_NOT_ACCEPTED: `Ci dispiace, {{$1: cardScheme}} non è accettata qui. Potrebbe provare con un'altra carta?`,
    ERROR_COUPON_CONFIRMATION: `Ci dispiace! Non è stato possibile utilizzare il codice coupon. La preghiamo di riprovare.`,
    ERROR_INVALID_EMAIL: `Indirizzo email non valido`,
    ERROR_INVALID_LOGIN_CREDS: `Nome utente/password non validi`,
    ERROR_INVALID_NAME: `La preghiamo di inserire un nome valido`,
    ERROR_INVALID_PHONE_NUMBER: `La preghiamo di inserire un numero di telefono valido`,
    ERROR_INVALID_ROOM_NUMBER: `La preghiamo di inserire un numero di camera valido`,
    ERROR_INVALID_TABLE_NUMBER: `La preghiamo di inserire un numero di tavolo valido`,
    ERROR_INVALID_VERIFICATION_CODE: `Codice di verifica non valido`,
    ERROR_KIOSK_CARD_DECLINED: `Qualcosa è andato storto. La sua carta non è stata addebitata. La preghiamo di riprovare.`,
    ERROR_KIOSK_CARD_DECLINED_TAP: `Lettura della carta non riuscita. La preghiamo di riprovare.`,
    ERROR_KIOSK_PAYMENT_DEVICE_NOT_FOUND: `Il chiosco non è riuscito a trovare il dispositivo di pagamento. La sua carta non è stata addebitata. La preghiamo di contattare un membro del personale.`,
    ERROR_KIOSK_PAYMENT_DEVICE_OFFLINE: `Il dispositivo di pagamento sembra essere offline. La sua carta non è stata addebitata. La preghiamo di contattare un membro del personale.`,
    ERROR_ORDER_OPERATION: `Ci dispiace, non siamo riusciti a elaborare il suo ordine. La preghiamo di riprovare.`,
    ERROR_PIN_LENGTH: `Il PIN non ha la lunghezza corretta.`,
    ERROR_RECEIVING_PAYMENT: `Il terminale non è riuscito a elaborare il suo pagamento. La preghiamo di riprovare.`,
    ERROR_RECEIVING_PAYMENT_INSTRUCTIONS: `Nessun pagamento è stato ricevuto. Questo ordine non è stato inviato. La sua ricevuta conterrà un riepilogo del suo ordine. La preghiamo di contattare un membro del personale per ulteriore assistenza.`,
    ERROR_SENDING_ORDER: `Salve, sembra esserci un problema nell'invio del suo ordine alla cucina. La preghiamo di contattare un membro del personale per assistenza.`,
    ERROR_SENDING_ORDER_INSTRUCTIONS: `Il pagamento è andato a buon fine, ma si è verificato un problema nell'invio del suo ordine alla cucina. La preghiamo di contattare un membro del personale per assistenza. La sua ricevuta conterrà un riepilogo del suo ordine.`,
    ERROR_STARTING_ORDER: `Ci dispiace, non siamo riusciti ad avviare il suo ordine. La preghiamo di riprovare. Se il problema persiste, contatti un membro del personale.`,
    ERROR_UPDATING_ORDER: `Ci dispiace, non siamo riusciti ad aggiornare il suo ordine. La preghiamo di riprovare. Se il problema persiste, contatti un membro del personale.`,
    ERROR_VIEWING_ITEM_ALCOHOL_LIMIT: `Impossibile visualizzare questo articolo. Ha raggiunto il limite di alcolici per questo ordine. La preghiamo di rimuovere una bevanda alcolica per aggiungere questa.`,
    ERROR_VIEWING_ITEM_SPECIAL_OFFER_LIMIT: `Impossibile visualizzare questo articolo. Ha raggiunto il limite di offerte speciali per questo ordine. La preghiamo di rimuovere un articolo in offerta speciale per aggiungere questo.`,
    EXIT: `Esci`,
    EXIT_CONFIRMATION: `È sicuro di voler uscire? Uscendo il suo ordine verrà annullato.`,
    EXIT_TO_COVER: ``,
    FAVORITE: `Preferito`,
    FAVORITES: `Preferiti`,
    FAVORITES_NONE_YET: `Ancora nessun preferito.`,
    FAVORITES_REMOVE_CONFIRMATION: `È sicuro di voler rimuovere questo preferito?`,
    FETCHING_RECOMMENDATIONS: `Recupero dei consigli in corso...`,
    FIND_ACCOUNT: `Trova account`,
    FIRST_NAME: `Nome`,
    FORGOT_PASSWORD: `Ha dimenticato la password?`,
    FULFILLMENT_LABEL_ADDRESS: `Indirizzo`,
    FULFILLMENT_LABEL_GUEST_EMAIL: `Email`,
    FULFILLMENT_LABEL_GUEST_NAME: `Per`,
    FULFILLMENT_LABEL_ORDER_NUMBER: `Numero dell'ordine`,
    FULFILLMENT_LABEL_TABLE_NUMBER: `Numero del tavolo`,
    FULFILLMENT_LABEL_PHONE_NUMBER: `Numero di telefono`,
    FULFILLMENT_LABEL_TRACKER_NUMBER: `Numero del localizzatore`,
    FULFILLMENT_LABEL_VEHICLE_DESCRIPTION: `Descrizione del veicolo`,
    FULFILLMENT_INSTRUCTION_ADDRESS: `Il suo ordine sarà consegnato all'indirizzo indicato di seguito.`,
    FULFILLMENT_INSTRUCTION_GUEST_EMAIL: `Le invieremo la ricevuta.`,
    FULFILLMENT_INSTRUCTION_GUEST_NAME: `Il suo nome sarà chiamato quando il suo ordine sarà pronto.`,
    FULFILLMENT_INSTRUCTION_ORDER_NUMBER: `Il suo numero d'ordine sarà chiamato.`,
    FULFILLMENT_INSTRUCTION_PHONE_NUMBER: `Riceverà un messaggio di testo quando il suo ordine sarà pronto.`,
    FULFILLMENT_INSTRUCTION_TABLE_NUMBER: `Il suo ordine sarà servito al suo tavolo.`,
    FULFILLMENT_INSTRUCTION_TRACKER_NUMBER: `Il suo localizzatore suonerà quando l'ordine sarà pronto.`,
    FULFILLMENT_INSTRUCTION_VEHICLE_DESCRIPTION: `Il suo ordine sarà portato fuori non appena sarà arrivato all'esterno del ristorante.`,
    FULFILLMENT_TOGGLE: `Cambia metodo di consegna attivo`,
    FULL_NAME: `Nome completo`,
    FUTURE_ORDER_MENU_FETCH_ERROR: `Ci dispiace! Non è stato possibile trovare il menu per quell'orario. La preghiamo di riprovare.`,
    FUTURE_ORDER_NO_AVAILABLE_SLOTS: `Ci dispiace! Non sono stati trovati orari disponibili. La preghiamo di provare con un'altra opzione di consumazione.`,
    FUTURE_ORDER_SET_FOR: `Ordine programmato per:`,
    FUTURE_ORDER_VALIDATION_WHEN_SLOT_EXPIRED_ERROR: `Ci dispiace! L'orario scelto non è più disponibile. La preghiamo di selezionare un orario diverso.`,
    FUTURE_ORDER_ERROR_FETCHING_SLOTS: `Qualcosa è andato storto durante la ricerca degli orari disponibili. La preghiamo di riprovare. Se il problema persiste, contatti un membro del personale.`,
    FUTURE_ORDER_ERROR_SELECT_SLOT: `La preghiamo di selezionare un orario.`,
    FUTURE_ORDER_TIME_SLOTS_TITLE: `Orari disponibili`,
    FUTURE_ORDER_TIME_SLOTS_TODAY: `Oggi`,
    FUTURE_ORDER_TIME_SLOTS_TOMORROW: `Domani`,
    FUTURE_ORDER_PICKUP_TIME_TODAY_AT: `Ritiro oggi alle {{$1: time}}`,
    FUTURE_ORDER_PICKUP_TIME_NEXT_BUSINESS_DAY_AT: `Ritiro il giorno lavorativo successivo alle {{$1: time}}`,
    FUTURE_ORDER_LEAD_TIME: `Tempo di preparazione stimato dell'ordine: {{$1: time}}`,
    GENERIC_ERROR: `Ops! Qualcosa è andato storto. La preghiamo di riprovare. Se il problema persiste, contatti un membro del personale.`,
    GET_REWARDS: `Ottieni premi`,
    GET_RECEIPT: `Ottieni ricevuta`,
    GET_RECEIPT_DIALOG_TITLE: `Opzioni ricevuta`,
    GIFT_CARD: `Carta regalo`,
    GIFT_CARD_SECONDARY: `Carta regalo alternativa`,
    GIFT_CARD_TITLE: `Paga ora`,
    GIFT_CARD_SUBTITLE: `Paghi passando la sua carta regalo nel lettore di carte.`,
    GIFT_CARD_SCANNING_ERROR_TITLE: `Errore nella scansione della carta regalo`,
    GIFT_CARD_SCANNING_ERROR_MESSAGE: `Non siamo riusciti a scansionare la sua carta regalo. La preghiamo di riprovare.`,
    GIFT_CARD_APPLYING_TITLE: `Applicazione carta regalo`,
    GIFT_CARD_APPLYING_ERROR_TITLE: `Errore nell'applicazione della carta regalo`,
    GIFT_CARD_APPLYING_ERROR_MESSAGE: `Non siamo riusciti ad applicare la sua carta regalo. La preghiamo di riprovare.`,
    GIFT_CARD_NO_BALANCE_TITLE: `Saldo carta regalo insufficiente`,
    GIFT_CARD_NO_BALANCE_MESSAGE: `La sua carta regalo non ha saldo.`,
    GIFT_CARD_ADD_ANOTHER: `Aggiungi un'altra`,
    GIFT_CARD_ENTERING_NUMBER_ERROR_REQUIRED: `La preghiamo di inserire un numero di carta regalo.`,
    GIFT_CARD_ENTERING_NUMBER_ERROR_INVALID: `La preghiamo di inserire un numero di carta regalo valido.`,
    GIFT_CARD_ENTERING_NUMBER_ERROR_LENGTH: `La preghiamo di inserire un numero di carta regalo valido.`,
    GIFT_CARD_ENTERING_PIN_ERROR_REQUIRED: `La preghiamo di inserire un PIN.`,
    GIFT_CARD_ENTERING_PIN_ERROR_INVALID: `La preghiamo di inserire un PIN valido.`,
    GIFT_CARD_ENTERING_PIN_ERROR_LENGTH: `La preghiamo di inserire un PIN valido.`,
    GIFT_CARD_ENTERING_NUMBER_HINT: `Inserisca il numero della carta regalo. I numeri possono avere {{$1: length}} cifre.`,
    GIFT_CARD_ENTERING_PIN_HINT: `Inserisca il PIN. I numeri possono avere {{$1: length}} cifre.`,
    GIFT_CARD_ERROR_REMOVING: `Errore nella rimozione della carta regalo. La preghiamo di riprovare. Se il problema persiste, contatti un membro del personale.`,
    'gift-card.select-account.title': `Selezioni un account`,
    'gift-card.select-account.loading': `Caricamento account...`,
    'gift-card.select-account.error.title': `Impossibile caricare gli account`,
    'gift-card.select-account.error.message': `Non siamo riusciti a caricare i suoi account. La preghiamo di riprovare.`,
    'gift-card.select-account.column.account': `Account`,
    'gift-card.select-account.column.balance': `Saldo attuale`,
    'gift-card.select-account.error.toast-title': `Errore`,
    'gift-card.select-account.error.toast-message': `Convalida non riuscita. La preghiamo di riprovare.`,
    GLOSSARY_TERM_LEARN_MORE: `Scopri di più`,
    GOES_WELL_WITH: `Si abbina bene con`,
    GRAND_TOTAL: `Totale complessivo`,
    GROUP_ORDERING_ADD_GUEST: `Aggiungi ospite`,
    GROUP_ORDERING_GUEST_NAME_INVALID_CHARACTERS: `Il nome dell'ospite contiene caratteri non validi.`,
    GROUP_ORDERING_GUEST_NAME_TAKEN: `Il nome dell'ospite è già in uso. La preghiamo di inserire un nome diverso.`,
    GROUP_ORDERING_GUEST_NUMBER_PREFIX: `Ospite {{$1: number}}`,
    GROUP_ORDERING_ITEM_FOR: `Ordine di gruppo - Per chi è questo articolo?`,
    GROUP_ORDERING_LABEL: `Ordine di gruppo - Articolo per:`,
    GROUP_ORDERING_TITLE: `Ordine di gruppo`,
    GROUP_ORDERING_SUBTITLE: `L'opzione ordine di gruppo le chiederà a quale membro del suo gruppo è destinato ciascun articolo. Tocchi “Sì” per attivare l'ordine di gruppo. Tocchi “No” se desidera continuare.`,
    GUEST_INFO: `Informazioni cliente`,
    GUEST_RATING_LABEL_0: `Tocchi per valutare con 0: Molto insoddisfatto`,
    GUEST_RATING_LABEL_1: `Tocchi per valutare con 1: Poco insoddisfatto`,
    GUEST_RATING_LABEL_2: `Tocchi per valutare con 2: Poco soddisfatto`,
    GUEST_RATING_LABEL_3: `Tocchi per valutare con 3: Molto soddisfatto`,
    GUEST_RATING_0: `Grazie per il suo feedback!`,
    GUEST_RATING_1: `Grazie per il suo feedback!`,
    GUEST_RATING_2: `Grazie per il suo feedback!`,
    GUEST_RATING_3: `Grazie per il suo feedback!`,
    GUEST_RATING_SUBMITTED: `Grazie per il suo feedback!`,
    HIDE: `Nascondi`,
    HOME: `Home`,
    HOW_DID_WE_DO: `Come siamo andati? Ci valuti!`,
    HOW_WOULD_YOU_LIKE_TO_PAY: `Come desidera pagare?`,
    HOW_WOULD_YOU_LIKE_YOUR_ORDER: `Come desidera il suo ordine?`,
    KITCHEN_CLOSED: `Ci dispiace, la cucina è chiusa.`,
    ID_CHECK_LABEL: `Il suo ordine contiene alcolici. Potrebbe esserle richiesto di mostrare un documento d'identità.`,
    ID_CHECK_CODE_MESSAGE: `È necessario un codice di accesso del dipendente per pagare con alcolici. La preghiamo di chiedere assistenza a un membro del personale.`,
    IE_WARNING: `Abbiamo notato che sta accedendo al nostro sito da Internet Explorer. Per un'esperienza migliore, lo apra con browser supportati come Google Chrome, Safari, Firefox o Microsoft Edge.`,
    INCLUDE_UTENSILS: `Includi posate`,
    ITEM_86D: `Salve, sembra esserci un problema nell'invio del suo ordine alla cucina perché un articolo è esaurito. La preghiamo di contattare un membro del personale per assistenza.`,
    ITEM_86D_VALIDATION: `Salve, sembra esserci un problema nell'invio del suo ordine alla cucina perché un articolo è esaurito. La preghiamo di chiedere assistenza a un membro del personale.`,
    ITEM_RECIPIENT: `Preparato per`,
    ITEM_RECIPIENT_FOR: `Preparato per {{$1: recipient}}`,
    ITEM_RECIPIENT_PLACEHOLDER: ``,
    ITEM_RECOMMENDED_BADGE: `Consigliato`,
    ITEM_STEP_TITLE: `Passo {{$1: step}}`,
    ITEM_STEP_EMPTY: `Nessuna scelta effettuata in questo passo`,
    ITEM_STEP_NO_RECOS: `Nessun consiglio disponibile`,
    ITEMS_NO_LONGER_IN_MENU: `Alcuni articoli sono stati rimossi dal suo carrello perché non sono più nel menu`,
    ITEM_SCAN_ERROR: `Non siamo riusciti a trovare questo articolo. La preghiamo di aggiungerlo dal menu o di contattare un membro del personale.`,
    ITEM_SCAN_SUCCESS: `Articolo aggiunto al carrello!`,
    LAST_NAME: `Cognome`,
    LEAD_TIME_LONG: `Il suo ordine potrebbe richiedere più tempo rispetto all'orario attualmente selezionato.`,
    LEAD_TIME_CART: `Questo ordine potrebbe richiedere più tempo per la preparazione rispetto all'orario di ritiro richiesto a causa di alcuni articoli selezionati.`,
    LANGUAGE_SELECT_LABEL: `Tocchi per selezionare la lingua`,
    LOADING: `Caricamento...`,
    LOADING_MENU: `Caricamento del menu...`,
    LOCATION_CARD_CLOSED: ``,
    LOCATION_CARD_LAST_VISITED: ``,
    LOCATION_CARD_OPEN: ``,
    LOCATION_CARD_SERVING_UNTIL: ``,
    LOCATION_CARD_OPENS_NEXT: ``,
    LOCATION_SEARCH_BUTTON: `Cerca punti vendita`,
    LOCATION_SEARCH_FULFILLMENT_PROMPT: `Trova un punto vendita per {{$1: dine-in/take-away}}`,
    LOCATION_SEARCH_FULFILLMENT_QUESTION: `Come desidera ordinare?`,
    LOCATION_SEARCH_HEADER: `Benvenuto in {{$1: org name}}`,
    LOCATION_SEARCH_INPUT_PLACEHOLDER: `Indirizzo, città e provincia, o codice postale`,
    LOCATIONS_CHOOSE_A_LOCATION: ``,
    LOCATIONS_ENTER_DIFFERENT_CODE: ``,
    LOCATIONS_NONE_AVAILABLE: ``,
    LOG_IN_OR_JOIN: `Accedi`,
    LOGIN: `Accedi`,
    LOGIN_GIFT_CARD: `Accesso con carta regalo`,
    LOGIN_GIFT_CARD_SECONDARY: `Accesso con carta regalo alternativa`,
    LOGIN_WALL_WELCOME: `Salve!`,
    LOGIN_WALL_WELCOME_USER: `Salve {{$1: user}}!`,
    LOGIN_WITH_CARD_NUMBER: `Accedi con numero di carta`,
    LOGIN_WITH_PHONE: `Accedi con il telefono`,
    LOOKING_UP_ACCOUNT: `Ricerca account in corso...`,
    LOOKUP_CARD: `Ricerca carta in corso...`,
    LOOKUP_COUPON: `Ricerca coupon in corso...`,
    LOYALTY: `Programma fedeltà`,
    LOYALTY_ACCOUNT_APPLY: `Applica`,
    LOYALTY_CARD_NUMBER: `Numero della carta`,
    LOYALTY_EXIT_TO_MENU: `Vai al menu`,
    LOYALTY_APP_AUTH_BARCODE_FALLBACK: `Scansiona il codice QR dell'app`,
    LOYALTY_APP_AUTH_PHONE_FALLBACK: `Nessuna app? Inserisca il suo numero di telefono.`,
    LOYALTY_AUTH_METHOD_BARCODE: `Scansiona il codice QR dell'app`,
    LOYALTY_AUTH_METHOD_HID: `Avvicina la carta HID`,
    LOYALTY_AUTH_METHOD_PHONE: `Inserisca il suo numero di telefono.`,
    LOYALTY_AUTH_METHOD_CARD_NUMBER: `Inserisca il suo numero di carta.`,
    LOYALTY_AUTH_METHOD_EMAIL: `Inserisca la sua email.`,
    LOYALTY_AUTH_METHOD_EMAIL_PASSWORD: `Inserisca la sua email e la sua password.`,
    LOYALTY_AUTH_METHOD_EMAIL_PHONE: `Inserisca la sua email e il suo numero di telefono.`,
    LOYALTY_AUTH_METHOD_USERNAME_PASSWORD: `Inserisca il suo nome utente e la sua password.`,
    LOYALTY_APP_AUTH_PHONE_FALLBACK_LABEL: `Inserisca il numero di telefono del suo account:`,
    LOYALTY_APP_AUTH_SUBTITLE: `Per trovare il codice a barre, apra la sua app alla schermata PAGA.`,
    LOYALTY_APP_AUTH_TITLE: `Scansioni il codice a barre di pagamento della sua app con lo scanner qui sotto.`,
    LOYALTY_APP_REDEMPTION_CODE_FALLBACK: `Inserisca manualmente il codice premio di 7 cifre`,
    LOYALTY_APP_REDEMPTION_CODE_FALLBACK_LABEL: `Inserisca un codice premio di 7 cifre:`,
    LOYALTY_APPLY_REWARD_FAILED: `Non è stato possibile applicare il premio. La preghiamo di riprovare.`,
    LOYALTY_APPLY_REWARD_FAILED_SPECIFIC: `Non è stato possibile applicare i seguenti premi: {{$1: reward names}}. La preghiamo di riprovare.`,
    LOYALTY_APPLYING_REWARD: `Applicazione premio...`,
    LOYALTY_AUTH_GENERIC_ERROR: `Ci dispiace! Non siamo riusciti a trovare questo account premi. La preghiamo di riprovare.`,
    LOYALTY_AUTH_INSTRUCTIONS: `Acceda per guadagnare e utilizzare i punti del suo programma premi.`,
    LOYALTY_AVAILABLE_REWARDS_LABEL: `Premi disponibili`,
    LOYALTY_BALANCE_DESCRIPTION: ``,
    LOYALTY_BALANCE_LABEL: `Saldo attuale`,
    LOYALTY_CANNOT_MODIFY_REWARD: `Ci dispiace, non può modificare i suoi premi dopo aver pagato l'ordine.`,
    LOYALTY_CANNOT_REMOVE_REWARD: `Ci dispiace, questo premio non può essere rimosso una volta applicato all'ordine.`,
    LOYALTY_CARD_NUMBER_INSTRUCTIONS: `Inserisca il suo numero di carta per guadagnare e utilizzare i punti del suo programma premi.`,
    LOYALTY_COUPON_BURNING_INCOMPATIBLE: `Ci dispiace, non può utilizzare i suoi premi perché è applicato un coupon.`,
    LOYALTY_GETTING_REWARDS: `Recupero dei suoi premi in corso...`,
    LOYALTY_FETCH_REWARDS_FAILED: `Non è stato possibile recuperare i premi. La preghiamo di riprovare.`,
    LOYALTY_REWARD_APPLY: `Applica`,
    LOYALTY_REWARD_APPLY_FAILED: `Non è stato possibile applicare i premi. Alcuni premi potrebbero non essere applicabili al suo ordine.`,
    LOYALTY_REWARD_APPLIED: `Applicato`,
    LOYALTY_REWARD_INVALID: `Non valido`,
    LOYALTY_REWARD_LABEL_MEAL: `Pasto`,
    LOYALTY_REWARD_LABEL_MEALS: `Pasti`,
    LOYALTY_REWARD_LABEL_UNSELECTED: `Riscatta ora`,
    LOYALTY_REWARD_LABEL_SELECTED: `Selezionato`,
    LOYALTY_REWARD_LABEL_APPLIED: `Riscattato`,
    LOYALTY_REWARD_LABEL_UNAPPLIED: `Riscattato al pagamento`,
    LOYALTY_REWARD_LABEL_REMOVING: `Rimozione in corso`,
    LOYALTY_REWARD_LABEL_ERROR: `Errore durante l'applicazione`,
    LOYALTY_REWARD_LABEL_UNAPPLICABLE: `Non applicabile`,
    LOYALTY_REWARD_GROUP_LABEL_UNKNOWN: `Premi`,
    LOYALTY_REWARD_GROUP_LABEL_PERCENT: `Premi in percentuale`,
    LOYALTY_REWARD_GROUP_LABEL_FIXED: `Premi fissi`,
    LOYALTY_REWARD_GROUP_LABEL_WALLET: `Premi del portafoglio`,
    LOYALTY_REWARD_GROUP_LABEL_WALLET_AND_PAYMENT: `Premi del portafoglio e di pagamento`,
    LOYALTY_REWARD_GROUP_LABEL_FREE_ITEM: `Premi articolo gratuito`,
    LOYALTY_REWARD_GROUP_LABEL_MEAL_EQUIVALENCY: `Premi scambio pasto`,
    LOYALTY_REWARDS_FOR: ` per`,
    LOYALTY_NO_REWARDS_LABEL: `Nessun premio`,
    LOYALTY_NO_REWARDS_NO_EARNING: `Nessun premio applicabile per questi articoli.`,
    LOYALTY_NO_REWARDS_TEXT: `Nessun premio applicabile per questi articoli, ma guadagnerà comunque punti con questo ordine!`,
    LOYALTY_PAYMENT: `Con programma fedeltà`,
    LOYALTY_PAYMENT_CARD_CHARGED: `Verranno addebitati {{$1: charge_amount}} sulla carta registrata.`,
    LOYALTY_PAYMENT_FAILED: `Impossibile applicare il pagamento.`,
    LOYALTY_PAYMENT_FAILED_MESSAGE: `Si è verificato un problema durante l'elaborazione del pagamento fedeltà. Riprovi o scelga un altro metodo di pagamento.`,
    USE_LOYALTY_PAYMENT: `Usa il programma fedeltà`,
    LOYALTY_PAYMENT_SUBMIT: `Effettua il pagamento`,
    LOYALTY_PAYMENT_REWARD: `Addebitato sul programma fedeltà`,
    LOYALTY_PAYMENT_REWARD_DESCRIPTION: `La carta registrata presso il fornitore verrà addebitata per questa transazione.`,
    LOYALTY_PAY_WITH_APP: `Paga con l'app`,
    LOYALTY_EARNED_POINT_ESTIMATE: `Punti premio stimati per questo ordine:`,
    LOYALTY_EARNED_POINT_ESTIMATE_METRIC: `{{$1: number }} punti`,
    LOYALTY_INTRO_ACCOUNT_STATUS: `Stato dell'account`,
    LOYALTY_INTRO_COULD_NOT_FIND_ACCOUNT: `Non abbiamo trovato il suo account.`,
    LOYALTY_INTRO_LOGIN_AND_EARN: `Acceda al suo account qui sotto per guadagnare punti e riscattare premi.`,
    LOYALTY_INTRO_PHONE_SIGN_UP: `Registrati con il numero di telefono`,
    LOYALTY_INTRO_PHONE_SIGN_UP_DESCRIPTION: `Può comunque guadagnare punti sul suo ordine di oggi scansionando la ricevuta dopo la registrazione!`,
    LOYALTY_INTRO_QR_SIGN_IN: `Scansioni il suo codice QR qui sotto per accedere.`,
    LOYALTY_INTRO_QR_SIGN_UP: `Scansioni il codice QR qui sotto per registrarsi.`,
    LOYALTY_INTRO_WELCOME_BACK: `Benvenuto, `,
    LOYALTY_FETCH_REWARDS_FAILED_NON_UNIQUE: `Il numero di telefono fornito è associato a più di un account fedeltà o non esiste.`,
    LOYALTY_REDEMPTION_CODE: `Applica codice di riscatto`,
    LOYALTY_REMOVING_REWARD: `Rimozione premio in corso...`,
    LOYALTY_SCAN_FAILED_TITLE: `Scansione non riuscita`,
    LOYALTY_SCAN_FAILED_MESSAGE: `Non siamo riusciti a scansionare il suo codice QR. Riprovi.`,
    LOYALTY_SIGN_OUT_NOTICE: `La sessione verrà chiusa automaticamente quando il suo ordine sarà effettuato o quando uscirà dal menu.`,
    LOYALTY_SIGN_OUT_NOTICE_PASSWORD: `La sessione verrà chiusa automaticamente quando il suo ordine sarà effettuato o quando uscirà dal menu. Le password non vengono mai salvate.`,
    LOYALTY_SIGN_UP_SMS_SENT: `Il messaggio di registrazione è stato inviato!`,
    LOYALTY_SIGN_UP_BACK_TO_LOGIN: `Torna all'accesso`,
    LOYALTY_SIGN_UP_SUCCESS_TITLE: `Registrazione riuscita!`,
    LOYALTY_SIGN_UP_WITH_QR: `Registrati con codice QR`,
    LOYALTY_SIGN_UP_WITH_PHONE_NUMBER: `Registrati con il numero di telefono`,
    LOYALTY_WELCOME_TITLE: `Guadagna e utilizza premi`,
    LOYALTY_SIGNUP_TITLE: `Ricevi un link di registrazione sul tuo telefono`,
    LOYALTY_YOU_CURRENTLY_HAVE: `Attualmente ha`,
    LOYALTY_NAV_REWARDS: `I miei premi`,
    LOYALTY_NAV_ORDER_HISTORY: `I miei ordini`,
    LOYALTY_SIGN_IN_ATTEMPTS_EXCEEDED: `Ha superato il numero massimo di tentativi di accesso.`,
    GIFT_CARD_ACCESS_ATTEMPTS_EXCEEDED: `Ha superato il numero massimo di tentativi di accesso alla carta regalo.`,
    MAKE_IT_A_COMBO: `Vuole farne un combo?`,
    MAKE_IT_A_COMBO_MOD: `Vuole aggiungerlo come combo?`,
    MAKE_IT_A_COMBO_ACCEPT: `Sì, grazie!`,
    MAKE_IT_A_COMBO_REJECT: `No, grazie!`,
    MAKE_IT_A_COMBO_NO: `No, grazie, senza combo.`,
    MAKE_IT_A_COMBO_YES: `Vuole farne un combo?`,
    MAKE_IT_A_COMBO_ACCEPTED_TITLE: `Ottima scelta!`,
    MAKE_IT_A_COMBO_ACCEPTED_MESSAGE: `Scelga il suo contorno e la sua bevanda qui sotto!`,
    MAKE_IT_A_COMBO_CHECKOUT_UPSELL_SUBTITLE: `Aggiunga un contorno e una bevanda per farne un combo!`,
    MENU_COVER_ALT_TEXT: `Tocchi qui per iniziare a ordinare`,
    MENU_COVER_LOYALTY_TEXT: `Acceda al programma fedeltà per guadagnare punti e riscattare premi.`,
    MENU_COVER_QUIZ_TEXT: `Completa il quiz per scoprire quale articolo fa per te!`,
    MENU_COVER_WAYFINDER_TEXT: `Vada al nostro localizzatore di percorsi per orientarsi`,
    MAINTENANCE_COVER_TITLE: `Questo chiosco è in manutenzione`,
    MAINTENANCE_HID_DISCONNECTED_MESSAGE: `Si assicuri che l'HID sia collegato al chiosco.`,
    MAINTENANCE_HID_DISCONNECTED_TITLE: `HID disconnesso`,
    MAINTENANCE_KDS_DISCONNECTED_MESSAGE: `Si assicuri che il KDS sia collegato al chiosco.`,
    MAINTENANCE_KDS_DISCONNECTED_TITLE: `KDS disconnesso`,
    MAINTENANCE_KIOSK_UNAVAILABLE_MESSAGE: `Provi un altro chiosco o chieda aiuto a un membro del personale.`,
    MAINTENANCE_KIOSK_UNAVAILABLE_TITLE: `Questo chiosco non è attualmente disponibile`,
    MAINTENANCE_MSR_DISCONNECTED_MESSAGE: `Si assicuri che il lettore di banda magnetica sia collegato al chiosco.`,
    MAINTENANCE_MSR_DISCONNECTED_TITLE: `Lettore di banda magnetica disconnesso`,
    MAINTENANCE_NETWORK_DISCONNECTED_MESSAGE: `Si assicuri che il chiosco sia collegato alla rete.`,
    MAINTENANCE_NETWORK_DISCONNECTED_TITLE: `Nessuna connessione di rete`,
    MAINTENANCE_NETWORK_UNSTABLE_MESSAGE: `Questo chiosco ha problemi di connessione a causa di una bassa velocità di internet.\n\nVerifichi che la sua connessione sia stabile.\n\nVelocità consigliata: minimo 10 Mbps in upload e download.`,
    MAINTENANCE_NETWORK_UNSTABLE_TITLE: `Rilevata rete instabile`,
    MAINTENANCE_PAYMENT_CLIENT_DISCONNECTED_MESSAGE: `Si assicuri che il dispositivo di pagamento sia acceso e collegato al chiosco.`,
    MAINTENANCE_PAYMENT_CLIENT_DISCONNECTED_TITLE: `Dispositivo di pagamento disconnesso`,
    MAINTENANCE_PRINTER_COVER_OPEN_MESSAGE: `Si assicuri che il coperchio della stampante sia chiuso.`,
    MAINTENANCE_PRINTER_COVER_OPEN_TITLE: `Coperchio della stampante aperto`,
    MAINTENANCE_PRINTER_DISCONNECTED_MESSAGE: `Si assicuri che la stampante sia collegata al chiosco.`,
    MAINTENANCE_PRINTER_DISCONNECTED_TITLE: `Stampante disconnessa`,
    MAINTENANCE_PRINTER_OUT_OF_PAPER_MESSAGE: `Si assicuri che la stampante abbia carta.`,
    MAINTENANCE_PRINTER_OUT_OF_PAPER_TITLE: `Stampante senza carta`,
    MAINTENANCE_SCALE_DISCONNECTED_MESSAGE: `Si assicuri che la bilancia sia collegata al chiosco.`,
    MAINTENANCE_SCALE_DISCONNECTED_TITLE: `Bilancia disconnessa`,
    MAINTENANCE_SCANNER_DISCONNECTED_MESSAGE: `Si assicuri che lo scanner sia collegato al chiosco.`,
    MAINTENANCE_SCANNER_DISCONNECTED_TITLE: `Scanner disconnesso`,
    MAX_ALCOHOLIC_ITEM_LIMIT_REACHED: `Il limite massimo di bevande alcoliche per ordine è {{$1: number}}`,
    MAX_SPECIAL_ITEM_LIMIT_REACHED: `Il limite massimo di articoli speciali per ordine è {{$1: number}}`,
    MENU_COVER_DINING_OPTIONS: `Come desidera ordinare?`,
    MENU_COVER_LANGUAGE_OPTIONS: `Selezioni una lingua per iniziare`,
    MENU_COVER_PROMO_ALT_TEXT_ITEM: `Tocchi qui per iniziare l'ordine e vedere questo articolo promozionato: {{$1: item name}}!`,
    MENU_COVER_PROMO_ALT_TEXT_SECTION: `Tocchi qui per iniziare l'ordine e andare direttamente a questa sezione promozionata: {{$1: section name}}!`,
    MENU_COVER_PROMO_ALT_TEXT_PAGE: `Tocchi qui per iniziare l'ordine e andare direttamente a questa pagina promozionata: {{$1: page name}}!`,
    MENU_COVER_DINING_OPTION_ALT_TEXT: `Tocchi qui per iniziare l'ordine per "{{$1: fulfillment method}}"!`,
    MENU_COVER_BACK_TO_DINING_OPTIONS: `Torna alle opzioni di consumo`,
    MENU_COVER_BACK_TO_PHONE_NUMBER: `Torna al numero di telefono`,
    MARKETING_CONSENT: `Desidero ricevere notizie, aggiornamenti, sconti e offerte`,
    MENU_FILTERS_DIETARY_FILTERS: `Dietetiche`,
    MENU_FILTERS_DIETARY_FILTERS_DESCRIPTION: `Per un'opzione più salutare, selezioni una di queste opzioni per mostrare solo quelle nel menu.`,
    MENU_FILTERS_NUTRITION_PREFERENCE: `Preferenze nutrizionali`,
    MENU_FILTERS_OTHER_FILTERS: `Altro`,
    MENU_FILTERS_OTHER_FILTERS_DESCRIPTION: ``,
    MENU_FILTERS_RESTRICTIVE_FILTERS: `Restrittivo`,
    MENU_FILTERS_RESTRICTIVE_FILTERS_DESCRIPTION: `Se ha determinate intolleranze, selezioni una di queste per nasconderle dal menu`,
    MENU_FILTERS_COUNT: `{{$1: number}} preferenze nutrizionali attive. Tocchi per modificare.`,
    MOD_86D: `Salve, sembra esserci un problema nell'invio del suo ordine alla cucina perché un articolo è esaurito. Contatti un membro del personale per assistenza. Tenga presente che il suo pagamento È stato accettato dal ristorante.`,
    MOD_GROUP_AGGREGATE_QUANTITY: `{{$1: number range, e.g. 2-3}} articoli in totale`,
    MOD_GROUP_CHOICES_INCREMENT: `multipli di {{$1: number, e.g. you have to get 2/4/6 sauces}}`,
    MOD_GROUP_CHOICES_MAKE_ONE: `faccia una scelta unica`,
    MOD_GROUP_CHOICES_MAKE_X: `faccia {{$1: number range, e.g. 2-3}} scelte diverse`,
    MOD_GROUP_CHOICES_QUANTITY_PER: `{{$1: number range, e.g. 2-3}} per scelta`,
    MOD_GROUP_CHOOSE_AT_LEAST_X: `Scelga almeno {{$1: number}}`,
    MOD_GROUP_CHOOSE_BETWEEN_X_AND_Y: `Scelga tra {{$1: number}} e {{$2: number}}`,
    MOD_GROUP_CHOOSE_ONE: `Scelga uno`,
    MOD_GROUP_CHOOSE_UP_TO_ONE: `Scelga fino a uno`,
    MOD_GROUP_CHOOSE_UP_TO_X: `Scelga fino a {{$1: number}}`,
    MOD_GROUP_CHOOSE_X: `Scelga {{$1: number}}`,
    MOD_GROUP_DEEMPHASIZE_SHOW: `Mostra - {{$1: mod_group}}`,
    MOD_GROUP_DEEMPHASIZE_HIDE: `Nascondi - {{$1: mod_group}}`,
    MOD_GROUP_WALLET_$_TO_SPEND: ``,
    MOD_GROUP_WALLET_ADDITIONAL_CHOICES_AT_$_PER: ``,
    MOD_GROUP_WALLET_FIRST_X_FREE: `I primi {{$1: number}} sono gratuiti.`,
    MOD_GROUP_WALLET_FIRST_SINGLE_FREE: `Il primo è gratuito.`,
    MOD_GROUP_WALLET_UP_TO_X: `Fino a {{$1: number}} a {{$2: dollar amount}} per scelta`,
    MOD_GROUP_SUBSTITUTION_MOD_CANCEL: `Chiudi sostituzione`,
    MOD_GROUP_SUBSTITUTION_MOD_CHANGE: `Cambia sostituzione`,
    MOD_GROUP_SUBSTITUTION_MOD_SELECT: `Sostituisci`,
    MOD_GROUP_SUBSTITUTION_UNSELECTED: `Aggiungi all'articolo`,
    MOD_RECOMMENDED_BADGE: `Consigliato`,
    MOD_UPSELL_PROMPT_TITLE: `Aggiungere opzione?`,
    MOD_UPSELL_PROMPT_ACCEPT: `Aggiungi`,
    MOD_UPSELL_PROMPT_DECLINE: `No, grazie`,
    MODIFY: `Modifica`,
    MODIFY_INGREDIENTS: `Modifica ingredienti`,
    MORE: `altro`,
    NAME_CALLED_ORDER_READY: `Il suo nome verrà chiamato quando il suo ordine sarà pronto.`,
    NAME_ON_CARD: `Nome sulla carta`,
    NEED_MORE_TIME: `Ha bisogno di più tempo?`,
    NEW_PASSWORD: `Nuova password`,
    NEXT: `Avanti`,
    NO: `No`,
    NO_ITEMS_MATCH_FILTERS: `Nessun articolo corrisponde ai suoi filtri.`,
    NO_ORDERS_MATCH: `Nessun ordine corrisponde alla sua ricerca.`,
    NO_THANKS: `No, grazie`,
    NO_TIP: `Nessuna mancia`,
    NOT_A_MEMBER: `Non è un membro?`,
    NUTRITION_INFO_CALORIES: `Cal`,
    NUTRITION_INFO_PROTEIN: `Proteine`,
    NUTRITION_INFO_FAT: `Grassi`,
    NUTRITION_INFO_CARBS: `Carboidrati`,
    NUTRITION_INFO_SUGAR: `Zuccheri`,
    OK: `OK`,
    OR: `o`,
    OPT_OUT_OF_RECOMMENDATIONS: `Rinuncia ai consigli`,
    ORDER_GET_ERROR: `Ci dispiace, abbiamo avuto problemi nella creazione del suo ordine. Riprovi.`,
    ORDER_HISTORY: `Cronologia ordini`,
    ORDER_HISTORY_EMPTY: `Non ci sono ordini nella sua cronologia. Una volta effettuato un ordine, apparirà qui.`,
    ORDER_HISTORY_ERROR: `Ci dispiace, abbiamo avuto problemi nel caricamento della sua cronologia ordini. Riprovi.`,
    ORDER_SENT: `Ordine inviato`,
    ORDER_SUMMARY: `Riepilogo dell'ordine`,
    ORDER_SUMMARY_WITH_NAME: `Riepilogo dell'ordine di {{$1 guest name}}`,
    ORDER_SUMMARY_LABEL: `Riepilogo dell'ordine. Ordine {{$1 fulfillment}}`,
    ORDER_SUMMARY_LABEL_WITH_NAME: `Riepilogo dell'ordine. Ordine {{$1 fulfillment}} per {{$2 guest name}}`,
    ORDER_SUMMARY_LABEL_WITH_TABLE: `Riepilogo dell'ordine. Ordine {{$1 fulfillment}} per il tavolo {{$2: table number}}`,
    ORDER_SUMMARY_LABEL_WITH_TRACKER: `Riepilogo dell'ordine. Ordine {{$1 fulfillment}} per il dispositivo di localizzazione #{{$2: tracker number}}`,
    ORDER_SUMMARY_LABEL_WITH_NAME_AND_TABLE: `Riepilogo dell'ordine. Ordine {{$1 fulfillment}} per {{$2 guest name}} al tavolo {{$3: table number}}`,
    ORDER_SUMMARY_LABEL_WITH_NAME_AND_TRACKER: `Riepilogo dell'ordine. Ordine {{$1 fulfillment}} per {{$2 guest name}} dispositivo di localizzazione #{{$3: tracker number}}`,
    ORDER_SUMMARY_LABEL_WITH_ORDER_NUMBER: `Riepilogo dell'ordine. Ordine {{$1 fulfillment}} per l'ordine #{{$2: order number}}`,
    ORDER_SUMMARY_LABEL_WITH_TRACKER_AND_ORDER_NUMBER: `Riepilogo dell'ordine. Ordine {{$1 fulfillment}} per il dispositivo di localizzazione #{{$2: tracker number}} per l'ordine #{{$3: order number}}`,
    ORDER_SUMMARY_LABEL_WITH_TABLE_AND_ORDER_NUMBER: `Riepilogo dell'ordine. Ordine {{$1 fulfillment}} per il tavolo {{$2: table number}} per l'ordine #{{$3: order number}}`,
    ORDER_SUMMARY_LABEL_WITH_NAME_AND_ORDER_NUMBER: `Riepilogo dell'ordine. Ordine {{$1 fulfillment}} per {{$2 guest name}} per l'ordine #{{$3: order number}}`,
    ORDER_SUMMARY_LABEL_WITH_NAME_TABLE_AND_ORDER_NUMBER: `Riepilogo dell'ordine. Ordine {{$1 fulfillment}} per {{$2 guest name}} al tavolo {{$3: table number}} per l'ordine #{{$4: order number}}`,
    ORDER_SUMMARY_LABEL_WITH_NAME_TRACKER_AND_ORDER_NUMBER: `Riepilogo dell'ordine. Ordine {{$1 fulfillment}} per {{$2 guest name}} al dispositivo di localizzazione {{$3: tracker number}} per l'ordine #{{$4: order number}}`,
    ORDER_THROTTLE_MAX_EXCEEDED: `Ci dispiace! Il ristorante sta ricevendo più ordini di quanti possa gestirne. Provi con un orario diverso.`,
    ORDER_TIME_ASAP: `Effettua un ordine il prima possibile`,
    ORDER_TIME_LATER: `Più tardi oggi`,
    ORDER_TIME_NEXT_BUSINESS_DAY: `Giorno lavorativo successivo`,
    ORDER_TIME_FUTURE: `Ordina per dopo`,
    ORDER_TOTAL_MAX_EXCEEDED: `Per ordini grandi, si rivolga a un membro del personale.`,
    ORDER_UPDATE_FAILED: `Impossibile aggiornare l'ordine.`,
    ORDER_VALIDATION_IN_PROGRESS: `Convalida del suo ordine in corso`,
    ORDER_VALIDATION_FAILED: `Ops! Qualcosa è andato storto.`,
    ORDER_WAS_PLACED: `Il suo ordine è stato effettuato.`,
    ORDERING_MODE_CHANGED: `Modalità di ordinazione cambiata. La sua sessione è stata reimpostata.`,
    ORDERED_ITEM_MAKE_IT_A_COMBO_LABEL: `Tocchi qui per trasformare {{$1: ordered item name}} in un combo.`,
    ORDERED_ITEM_COMBO_LABEL: `Combo`,
    ORDERING_ITEM_ABSENCE_RESET: `Questo articolo non era aggiornato. L'articolo è stato reimpostato al suo stato iniziale. Riprovi.`,
    OUR_MENU: `Il nostro menu`,
    OUTPOST_PICKUP: `Ritiro al punto di consegna`,
    OUTPOST_ROOM_NUMBER_INSTRUCTION: `Inserisca il numero della sua stanza al punto di consegna`,
    OUTPOST_ROOM_NUMBER_TITLE: `Numero della stanza`,
    OUT_OF_STOCK: `Esaurito`,
    PAGE_NAVIGATION_TITLE: `Tocchi una delle opzioni qui sotto per andare a una pagina specifica del menu. {{$1: total}} pagine disponibili.`,
    PAGE_NOT_FOUND: ``,
    PAGE_NOT_FOUND_MESSAGE: ``,
    PAGE_ERROR: ``,
    PAGE_ERROR_MESSAGE: ``,
    GO_TO_HOME_PAGE: ``,
    PARTIAL_PAYMENT_LINE: `Pagamento parziale`,
    PARTIAL_PAYMENT_WARNING_TITLE: `Pagamento parziale`,
    PARTIAL_PAYMENT_WARNING_MESSAGE: `C'è un pagamento parziale su questo ordine. Se desidera tornare indietro, il suo pagamento verrà prima rimborsato.`,
    PASSWORD: `Password`,
    PASSWORD_REQUIREMENTS: ``,
    PASSWORD_UPDATED: ``,
    PASSWORD_UPDATED_LOG_IN_AGAIN: ``,
    PARTIAL_TENDER_TIMEOUT: `Salve, se non completa il pagamento entro i prossimi 5 minuti, annulleremo l'ordine e rimborseremo il suo pagamento.`,
    PAY_AT_CASHIER: `Si rechi alla cassa per pagare.`,
    PAY_NOW: `Paga ora`,
    PAY_WITH: `Paga con`,
    PAY_WITH_CREDIT: `Paga con carta di credito`,
    PAY_WITH_DEBIT_CREDIT: `Paga con debito/credito`,
    PAYMENT: `Pagamento`,
    PAYMENT_DETAILS: `Dettagli del pagamento`,
    PAYMENT_LINE_LABEL_DONATION: `Donazione per {{$1: amount}}`,
    PAYMENT_LINE_LABEL_SUBTOTAL: `Il subtotale è {{$1: amount}}`,
    PAYMENT_LINE_LABEL_PARTIAL: `Pagamento parziale per {{$1: amount}}`,
    PAYMENT_LINE_LABEL_GIFT_CARD: `Riscatto carta regalo da {{$1: name}} per {{$2: amount}}`,
    PAYMENT_LINE_LABEL_COUPON: `Sconto coupon da {{$1: name}} per {{$2: amount}}`,
    PAYMENT_LINE_LABEL_COMP_CARD: `Sconto coupon da {{$1: name}} per {{$2: amount}}`,
    PAYMENT_LINE_LABEL_EBT: `Pagamento con EBT per {{$1: amount}}`,
    PAYMENT_LINE_LABEL_LOYALTY: `Riscatto premi da {{$1: name}} per {{$2: amount}}`,
    PAYMENT_LINE_LABEL_REWARD: `Riscatto premio da {{$1: name}} per {{$2: amount}}`,
    PAYMENT_LINE_LABEL_DISCOUNT: `Sconto da {{$1: name}} di {{$2: amount}}`,
    PAYMENT_LINE_LABEL_TAX: `L'imposta è {{$1: amount}}`,
    PAYMENT_LINE_LABEL_TIP: `La mancia è {{$1: amount}}`,
    PAYMENT_LINE_LABEL_SERVICE_CHARGE: `Il costo del servizio è {{$1: amount}}`,
    PAYMENT_LINE_LABEL_NAMED_SERVICE_CHARGE: `Il costo del servizio è {{$1: amount}} per {{$2: name}}`,
    PAYMENT_LINE_LABEL_TOTAL: `Il totale complessivo è {{$1: amount}}`,
    PAYMENT_LINE_LABEL_REMAINING: `Il saldo residuo è {{$1: amount}}`,
    PAYMENT_LINE_LABEL_PAID: `L'importo pagato è {{$1: amount}}`,
    PAYMENT_OPTION_LABEL_CASH: `Tocchi per pagare in contanti`,
    PAYMENT_OPTION_LABEL_CARD: `Tocchi per pagare con carta di credito`,
    PAYMENT_OPTION_LABEL_COUPON: `Tocchi per riscattare un coupon`,
    PAYMENT_OPTION_LABEL_COMP_CARD: `Tocchi per riscattare una carta omaggio`,
    PAYMENT_OPTION_LABEL_DONATION: `Tocchi per fare o modificare donazioni`,
    PAYMENT_OPTION_LABEL_EBT: `Tocchi per pagare con EBT`,
    PAYMENT_OPTION_LABEL_EBT_REFUND: `Tocchi per rimborsare EBT`,
    PAYMENT_OPTION_LABEL_EBT_CASH_BENEFIT: `Tocchi per pagare con EBT Cash Benefit`,
    PAYMENT_OPTION_LABEL_EBT_FOOD_STAMPS: `Tocchi per pagare con SNAP EBT`,
    PAYMENT_OPTION_LABEL_GIFT_CARD: `Tocchi per pagare con una carta regalo`,
    PAYMENT_OPTION_LABEL_LOYALTY: `Tocchi per riscattare i premi`,
    PAYMENT_OPTION_LABEL_LOYALTY_PAYMENT: `Tocchi per riscattare i premi`,
    PAYMENT_OPTION_LABEL_FULLY_PAID: `Tocchi per completare il pagamento`,
    PAYMENT_PROMPT_NFC: `Paghi con il lettore di carte inserendo la carta o avvicinando il telefono.`,
    PAYMENT_PROMPT_DIP: `Paghi con il lettore di carte inserendo la carta.`,
    PAYMENT_SUCCESSFUL: `Pagamento riuscito`,
    PAYMENT_SUCCESSFUL_SUBTITLE: ``,
    PAYMENT_KIOSK_ERROR: `Siamo spiacenti, il pagamento non è andato a buon fine. Riprovi.`,
    PAYMENT_KIOSK_TIMEOUT: `Siamo spiacenti, la sessione di pagamento è scaduta. Riprovi.`,
    PAYMENT_TOTAL: `Totale del pagamento`,
    PAYMENT_WAS_TAKEN: `La informiamo che il suo pagamento è stato eseguito.`,
    PAYMENT_WAS_NOT_TAKEN: `La informiamo che il suo pagamento non è stato eseguito. Questa non è una conferma di pagamento.`,
    PHONE_NUMBER: `Numero di telefono`,
    PICK_UP: `Ritiro`,
    PICK_UP_AT: `Ritiro presso`,
    PICK_UP_ENTER_NUMBER: `Prenda un numero e lo inserisca qui sotto:`,
    PICK_UP_ENTER_NUMBER_WITH_NAME: `Ciao {{$1: guest name}}, prenda un numero e lo inserisca qui sotto:`,
    PICK_UP_ENTER_NUMBER_TRACKER: `Prenda un localizzatore e inserisca il suo numero:`,
    PICK_UP_ENTER_NUMBER_TRACKER_WITH_NAME: `Ciao {{$1: guest name}}, prenda un localizzatore e inserisca il suo numero:`,
    PLACE_ORDER: `Invia ordine`,
    PLEASE_ENTER_A_VALID_AMOUNT: `Inserisca un importo valido da rimborsare.`,
    PLEASE_USE_TEST_CARD: `Questa sede è ancora in modalità di prova. Usi una carta di prova per pagare.`,
    PLEASE_WAIT: `Attenda, prego...`,
    PRICE: `Il prezzo è {{$1:price}}`,
    PRINTING_RECEIPT: `Stampa della ricevuta in corso...`,
    PRINT_RECEIPT: `Stampa ricevuta`,
    PRINT_RECEIPT_ERROR: `Siamo spiacenti, si è verificato un errore durante la stampa della ricevuta. Riprovi più tardi.`,
    PRINTED_RECEIPT_COMMAND: `Ricordi di prendere la sua ricevuta!`,
    PROCESSING_PAYMENT: `Elaborazione del pagamento...`,
    PROMOTED_MODIFIER: `Promozione attivata!`,
    QUANTITY_SELECT: `{{$1:quantity}} selezionati`,
    QUANTITY_SELECT_INCREASE: `Aumenta quantità`,
    QUANTITY_SELECT_DECREASE: `Riduci quantità`,
    QUANTITY_SELECT_LABEL: ``,
    QUIT: `Esci`,
    QUICK_CHECKOUT: `Pagamento rapido`,
    QUICK_NAV_TAP_TO_VIEW: `Tocchi per vedere:`,
    QUIZ_RESULTS_TITLE: `Risultati`,
    QUIZ_RESULTS_EMPTY: `Nessun risultato trovato. Riprovi con risposte diverse.`,
    QUIZ_RESULTS_CAROUSEL_NEXT_LABEL: `Tocchi per vedere il risultato successivo. {{$1:index}} di {{$2:total}}`,
    QUIZ_RESULTS_CAROUSEL_PREV_LABEL: `Tocchi per vedere il risultato precedente. {{$1:index}} di {{$2:total}}`,
    QUIZ_STEP_ERROR: `Risponda a tutte le domande prima di continuare.`,
    QUIZ_STEP_ANSWER_LABEL: `Tocchi per rispondere con {{$1:badge name}}:`,
    QR_CODE_RECEIPT_INSTRUCTIONS: `Scansioni il codice QR per ottenere una copia della ricevuta sul suo telefono.`,
    RECEIPT_AUTHORIZATION: `Autorizzazione`,
    RECEIPT_CARD_NUMBER: `Carta n.`,
    RECEIPT_CHECK_ID: `VERIFICARE IL DOCUMENTO`,
    RECEIPT_DISCOUNTS: `Sconti`,
    RECEIPT_DONATION: `Donazione`,
    RECEIPT_FAILED: `Salve, sembra esserci un problema nell'invio del suo ordine alla cucina.\n\nContatti un membro del personale per assistenza.`,
    RECEIPT_FAILED_ITEM_86D: `Salve, sembra esserci un problema nell'invio del suo ordine alla cucina perché un articolo è esaurito. Contatti un membro del personale per assistenza.`,
    RECEIPT_LOYALTY_POINTS_EARNED_TEXT: ``,
    RECEIPT_MENU_ITEMS_WITHOUT_BARCODE: `I seguenti articoli non sono stati inclusi nel codice QR perché non hanno un PLU associato:`,
    RECEIPT_NOT_RECEIPT: `Questa non è una ricevuta né una prova d'acquisto.`,
    RECEIPT_ORDER: `ORDINE`,
    RECEIPT_ORDER_TOTAL: `Totale dell'ordine`,
    RECEIPT_PAY_AT_CASHIER: `PAGARE ALLA CASSA`,
    RECEIPT_PICK_UP_AT_LABEL: `Ritiro presso`,
    RECEIPT_PICKUP_TIME_LABEL: `Orario di ritiro`,
    RECEIPT_DELIVERY_TIME_LABEL: `Orario di consegna`,
    RECEIPT_PRINTED: `Ricevuta stampata`,
    RECEIPT_REFUNDED: `Rimborsato`,
    RECEIPT_REMAINING_BALANCE: `Saldo residuo`,
    RECEIPT_SELF_SERVE: `Self-service:`,
    RECEIPT_SPECIAL_REQUEST: `Richiesta speciale`,
    RECEIPT_SUB_TOTAL: `Subtotale`,
    RECEIPT_TAX_TOTAL: `Imposta`,
    RECEIPT_TIP_THANKS: `Mancia (Grazie!)`,
    RECEIPT_SERVICE_CHARGE: `Costo del servizio`,
    RECEIPT_TRANS_NO: `N. TRANSAZ. CHIOSCO`,
    RECEIPT_YOUR_CHECK_NUMBER: `Il suo numero di conto è`,
    RECOMMENDATIONS: `Consigli`,
    RECOMMENDED_FOR_YOU: `Consigliato per lei`,
    REFUND: `Rimborso`,
    REFUNDER_ALREADY_REFUNDED: `Rimborsato`,
    REFUNDER_DELAY_MESSAGE: `I rimborsi possono richiedere alcuni giorni per apparire sull'estratto conto.`,
    REFUNDER_INSTRUCTIONS: `Per cercare gli ordini, usi il numero di autorizzazione sulla ricevuta, il numero dell'ordine, l'indirizzo email, il numero di telefono, le ultime quattro cifre della carta, il numero di riferimento della transazione o l'orderId.`,
    REFUNDER_SEARCH_PLACEHOLDER: `Numero di autorizzazione della ricevuta, numero dell'ordine o ultime quattro cifre della carta`,
    REFUNDER_TITLE: `Rimborsa un ordine`,
    REFUNDER_SEARCHING_TITLE: `Ricerca in corso`,
    REFUNDER_RESULTS_TITLE: `Ordini`,
    REFUNDER_RESULTS_EMPTY: `Nessun ordine trovato. Verifichi i criteri di ricerca e riprovi.`,
    REFUNDER_REFUNDING_TITLE: `Rimborso in corso`,
    REFUNDER_REFUND_ERROR: `Si è verificato un errore durante l'elaborazione del rimborso. Riprovi. Se il problema persiste, contatti l'assistenza.`,
    REFUNDER_REFUND_SUCCESS: `Rimborso riuscito! La transazione sarà elaborata a breve.`,
    REFUNDER_REFUND_SUCCESS_BACK: `Cerca di nuovo`,
    REFUNDER_SEARCH_INPUT_ERROR: `Inserisca un numero di autorizzazione, un numero dell'ordine o le ultime quattro cifre della carta validi.`,
    REFUNDER_SEARCH_ERROR: `Si è verificato un errore durante la ricerca dell'ordine. Riprovi. Se il problema persiste, contatti l'assistenza.`,
    REFUNDING: `Elaborazione del rimborso...`,
    REFUND_FAILED: `Rimborso non riuscito. Riprovi più tardi.`,
    REMOVE: `Rimuovi`,
    REMOVE_CARD: `Non dimentichi di ritirare la sua carta.`,
    REMOVE_COMP_CARD: `Rimuovi carta omaggio`,
    REMOVE_COUPON: `Rimuovi coupon`,
    REMOVE_GIFT_CARD: `Rimuovi`,
    REMOVE_TIP: `Rimuovi mancia`,
    REMOVING_COUPON: `Rimozione del coupon...`,
    REORDER: ``,
    REPEAT_PASSWORD: `Ripeti la password`,
    RESET: `Reimposta`,
    REWARDS: `Premi`,
    REWARDS_LOGGED_IN: `Premi`,
    REWARDS_APPLICABLE_TO_ORDER: `Applicabile ora al suo ordine`,
    REWARDS_NOT_APPLICABLE_TO_ORDER: `Non ancora applicabile al suo ordine`,
    REWARDS_EDIT: `Modifica premi`,
    REWARDS_BALANCE_POINT_LABEL: `{{$1: number}} punti`,
    REWARDS_BALANCE_MEAL_EQUIVALENCY_LABEL: `{{$1: number}} pasti`,
    REWARDS_COST_POINT_LABEL: `{{$1: number}} punti`,
    SAVE: `Aggiorna`,
    SAVE_CARD: `Salva la carta sull'account per acquisti futuri.`,
    SCAN_COUPON_BELOW: `Può scansionare i coupon con lo scanner qui sotto.`,
    SCAN_YOUR_GIFT_CARD: `Scansioni la sua carta regalo`,
    SEARCH: `Cerca`,
    SEARCH_BEGIN: `Inserisca il termine di ricerca qui sotto per iniziare a cercare.`,
    SEARCH_EMPTY: `Nessun risultato trovato. Provi un termine di ricerca diverso.`,
    SEARCH_HINT: `Cerchi articoli usando qualsiasi combinazione di nome o descrizione.`,
    SECRET_MENU_IMAGE_ALT: `Tocchi per vedere il menu segreto`,
    SELECT_DATE: `Seleziona data`,
    SELF_SERVE: `Self-service`,
    SEND: `Invia`,
    SEND_LOYALTY_SMS: `Invia SMS`,
    SEND_ORDER_UI_TIMEOUT: `Salve, stiamo ancora cercando di inviare il suo ordine alla cucina. Contatti un membro del personale per assistenza.`,
    SENT_LOYALTY_SIGNUP_SMS: `SMS inviato. Controlli il suo telefono e si registri quando vuole.`,
    SENDING_ORDER_KITCHEN: `Invio dell'ordine alla cucina...`,
    SENDING_ORDER_VALIDATION: `Conferma dell'ordine...`,
    SENDING_RECEIPT: `Invio della ricevuta...`,
    SENDING_SMS: `Invio SMS...`,
    SERVICE_CHARGE: `Costo del servizio`,
    SHOW: `Mostra`,
    SHOW_NUTRITION: `Mostra valori nutrizionali`,
    SHOW_STAFF_FIRST: `Mostri questo messaggio a un membro del personale prima di uscire.\nUscire davvero?`,
    SIGNUP_CTA: `Si registri per un account!`,
    SIGN_OUT: `Esci`,
    SIGN_UP: `Registrati`,
    SIGNUP_BENEFITS: `Crei un account per salvare la sua carta di credito e gli articoli preferiti per un pagamento più facile.`,
    SIGNUP_LOYALTY: `Registrati al programma fedeltà`,
    SKIP: `Salta`,
    SPECIAL_REQUESTS: `Richieste speciali`,
    SPECIAL_REQUESTS_EXAMPLE: `es: salsa a parte, senza acciughe, ecc.`,
    SPECIAL_REQUESTS_FINEPRINT: `Sostituzioni e richieste possono comportare un costo aggiuntivo.`,
    SPECIAL_REQUESTS_ADD: `Aggiungi richiesta speciale`,
    SPECIAL_REQUESTS_ERROR_TOO_LONG: `La richiesta speciale è troppo lunga.`,
    SPECIAL_REQUESTS_ERROR_NO_INVALID_CHARACTERS: `Usi solo lettere, numeri e punteggiatura.`,
    SPECIAL_REQUESTS_ERROR_NO_VALUE: `Inserisca una richiesta speciale.`,
    SR_REMOVE_ITEM_FROM_CART: `Rimuovi articolo dal carrello.`,
    STARTING_ORDER: `Avvio dell'ordine...`,
    UPDATING_ORDER: `Aggiornamento dell'ordine...`,
    START_ORDER_BY_SCANNING: `Inizi il suo ordine scansionando un articolo nella parte inferiore del chiosco.`,
    START_NEW_ORDER: `Inizia un altro ordine`,
    STORED_VALUE_REMAINING_BALANCE: `rimanenti`,
    STORE_INFO: ``,
    STORE_INFORMATION: `Informazioni sul punto vendita`,
    STUDENT_CARD: `Tessera studente`,
    STUDENT_CARD_INSUFFICIENT_FUNDS: `Siamo spiacenti, questa tessera studente non ha fondi.`,
    STUDENT_CARD_SUBTITLE_HID: `Avvicini la sua tessera studente per pagare`,
    STUDENT_CARD_SUBTITLE_HID_MSR: `Avvicini o strisci la sua tessera studente per pagare`,
    STUDENT_CARD_SUBTITLE_MSR: `Strisci la sua tessera studente per pagare`,
    SUBMIT: `Invia`,
    SUBTOTAL: `Subtotale`,
    SUBTOTAL_REDUCED: `Subtotale ridotto`,
    SUBTOTAL_INCREASED: `Nuovo subtotale`,
    SUBTOTAL_WARNING_COMBO_SAVE_TITLE: `Sta risparmiando con un combo!`,
    SUBTOTAL_WARNING_COMBO_SAVE_LINE: `Lei risparmia`,
    SUCCESS: `Riuscito`,
    SUMMARY_STEP_FOOTNOTE: ``,
    SUMMARY_STEP_NOTICE: ``,
    SWITCH_LOCATION: `Cambia sede`,
    SWITCH_TO_CATERING: `Passa al servizio catering`,
    SWITCH_TO_WEB: `Passa all'ordinazione online`,
    SWIPE_YOUR_GIFT_CARD: `Strisci la sua carta regalo per pagare`,
    SWIPE_YOUR_COMP_CARD: `Strisci la sua carta omaggio per pagare`,
    SWIPE_OR_SCAN_YOUR_GIFT_CARD: `Strisci o scansioni la sua carta regalo per pagare`,
    TAKING_LONGER_THAN_USUAL: `Sta impiegando più tempo del solito...`,
    TAP_HERE_FOR_LANGUAGE: `Tocchi qui per {{$1: language}}`,
    TAP_OUTSIDE_CLOSE: `Tocchi fuori per chiudere`,
    TAP_TO_REDEEM: `Tocchi per riscattare`,
    TAXES: `Imposta`,
    TERMS_OF_SERVICE: `Termini di servizio`,
    TERMS_OF_SERVICE_LOAD_FAILED: `Errore durante il caricamento dei Termini di servizio`,
    TEXT_RECEIPT: `Ricevuta via SMS`,
    TEXT_RECEIPT_SEND_FAILED: `Impossibile inviare la ricevuta via SMS.`,
    TEXT_RECEIPT_SEND_SUCCESS: `Ricevuta inviata!`,
    TEXT_YOU_WHEN_READY: `Le invieremo un SMS quando il suo ordine sarà pronto.`,
    THANK_YOU: `Grazie!`,
    THEN_PRESS_BUTTON_1: `Poi prema il`,
    THEN_PRESS_BUTTON_2: `pulsante.`,
    TIP: `Mancia`,
    TIPPING: `Aggiunta della mancia...`,
    TIP_AMOUNT_TOO_HIGH: `L'importo della mancia è troppo alto.`,
    TIP_AMOUNT_TOO_LOW: `L'importo della mancia è troppo basso.`,
    TIP_FAILED: `Siamo spiacenti! Impossibile aggiungere una mancia. Riprovi.`,
    TIP_CANNOT_BE_MODIFIED: `Siamo spiacenti! Non può modificare la mancia dopo aver pagato l'ordine.`,
    TIP_LABEL_PERCENT: `Tocchi per aggiungere una mancia del {{$1: percent}}% ({{$2: amount}})`,
    TIP_LABEL_FIXED: `Tocchi per aggiungere una mancia di {{$1: amount}}`,
    TIP_LABEL_CUSTOM: `Tocchi per aggiungere una mancia personalizzata`,
    TIP_LABEL_NONE: `Tocchi per rimuovere la mancia`,
    TO_GO: `Da asporto`,
    TOTAL: `Totale`,
    TOTAL_CHANGED_SUBTOTAL_TEXT: `I prezzi di alcuni articoli del suo ordine sono cambiati.`,
    TOTAL_CHANGED_SUBTOTAL_LEADING_TEXT: `Il subtotale è cambiato ed è ora`,
    TOTAL_CHANGED_LEADING_TEXT: `Il totale è cambiato ed è ora`,
    TOTAL_CHANGED_TRAILING_TEXT: `. Desidera continuare con l'ordine?`,
    TOTAL_PAID: `Totale pagato`,
    TOTAL_REMAINING: `Totale residuo`,
    TOTAL_SUBSCRIPT: ``,
    TRY_AGAIN: `Riprova`,
    UNABLE_TO_FETCH_LOCATION_EXPLANATION: `Sembra che non siamo riusciti a trovare il suo indirizzo. Inserisca il suo indirizzo.`,
    UNAVAILABLE_ITEM: `Siamo spiacenti, questo articolo non è più disponibile.`,
    UNIT_GRAM: `{{$1: amount}}g`,
    UNIT_NUTRITION_INFO_CALORIES: `{{$1: amount}} calorie`,
    UNIT_NUTRITION_INFO_PROTEIN: `{{$1: amount}} proteine`,
    UNIT_NUTRITION_INFO_CARBS: `{{$1: amount}} carboidrati`,
    UNIT_NUTRITION_INFO_FAT: `{{$1: amount}} grassi`,
    UNIT_NUTRITION_INFO_SUGAR: `{{$1: amount}} zuccheri`,
    UP_TO_X: `fino a {{$1: number}}`,
    USE_COMP_CARD: `Usa carta omaggio`,
    USE_COUPON: `Usa coupon`,
    USE_EBT_CARD: `Carta EBT`,
    USE_EBT_CASH_BENEFIT: `Beneficio in contanti EBT`,
    USE_EBT_FOOD_STAMP: `Buoni pasto EBT`,
    USE_GIFT_CARD: `Usa carta regalo`,
    USERNAME: `Nome utente`,
    VALIDATION_MESSAGE_EMAIL_IS_INVALID: `L'indirizzo email non è valido`,
    VALIDATION_MESSAGE_FIELD_IS_REQUIRED: `{{$1: field name, e.g. 'email'}} è obbligatorio`,
    VALIDATION_MESSAGE_FIELD_IS_REQUIRED_GENERIC: `Questo campo è obbligatorio`,
    VALIDATION_MESSAGE_ONLY_LETTERS_AND_NUMBERS: `Utilizzi solo lettere e numeri`,
    VALIDATION_MESSAGE_ONLY_LETTERS_NUMBERS_AND_SPECIAL_CHARS: `Utilizzi solo lettere, numeri, &, # o .`,
    VALIDATION_MESSAGE_PASSWORD_REQUIREMENTS: `La password deve contenere almeno 1 cifra, 1 lettera maiuscola, 1 lettera minuscola ed essere lunga almeno 14 caratteri.`,
    VALIDATION_MESSAGE_PHONE_NUMBER_IS_INVALID: `Il numero di telefono non è valido`,
    VALIDATION_MESSAGE_POSTAL_CODE_IS_INVALID: `Il codice postale deve essere numerico`,
    VENDOR_UNAVAILABLE_MESSAGE: `Questo punto vendita è attualmente chiuso. Verifichi gli orari di apertura e torni in un altro momento.`,
    VEHICLE_COLOR: `Colore del veicolo`,
    VEHICLE_MAKE: `Marca del veicolo`,
    VEHICLE_MODEL: `Modello del veicolo`,
    VERIFY_ACCOUNT: `Verifica account`,
    VERIFY_ACCOUNT_CTA: `Verifichi il suo account per iniziare a ordinare.`,
    VIDEO_LOAD_FAILED: `Impossibile caricare il video`,
    VIEW: `Visualizza`,
    WE_APOLOGIZE: `Ci scusiamo per l'inconveniente.`,
    WEIGHING_INSTRUCTIONS: `Posizioni il suo articolo sulla bilancia.`,
    WELCOME_BACK: `Bentornato! Articoli selezionati apposta per lei:`,
    WELCOME_BACK_WITH_NAME: `Bentornato {{$1: guest name}}! Articoli selezionati apposta per lei:`,
    WELCOME_TO: `Benvenuto da {{$1: org name}}!`,
    WELCOME_TO_NO_NAME: ``,
    WHEN_WOULD_YOU_LIKE_YOUR_ORDER: `Scegli l'orario dell'ordine`,
    WHICH_OUTPOST_FOR_YOUR_ORDER: `Dove desidera ricevere il suo ordine?`,
    YES: `Sì`,
    YOU_PREVIOUSLY_ORDERED: `Ha ordinato in precedenza`,
    YOUR_CURRENT_LOCATION: `La sua posizione attuale`,
    YOUR_NAME: `Il suo nome`,
    YOUR_ORDER: `Il suo ordine`,
    YOUR_SUBTOTAL: `Il suo subtotale`,
    ZOOM_TOGGLE_ON: `Tocchi per attivare lo zoom con due dita`,
    ZOOM_TOGGLE_OFF: `Tocchi per disattivare lo zoom con due dita`,
    ZOOM_INSTRUCTIONS: `Lo zoom con due dita è attivato. Usi due dita per ingrandire e rimpicciolire.`,
    STARBUCKS_COVER_1_BUTTON: `So cosa voglio`,
    STARBUCKS_COVER_2_BUTTON: `Esplora`,
    STARBUCKS_COVER_2_TITLE: `Esperienze, degustazioni, apprendimento`,
    STARBUCKS_COVER_PROMO_A: `Trova il tuo caffè`,
    STARBUCKS_COVER_PROMO_B: `Starbucks Rewards`,
    STARBUCKS_EXPERIENCES_TITLE: `Esperienze`,
    STARBUCKS_EXPERIENCES_SUBTITLE: `Si immerga nell'artigianalità, nello spettacolo e nell'innovazione del caffè prenotando un'Esperienza Signature`,
    STARBUCKS_EXPERIENCES_RESERVE_NOW: `Prenota per oggi`,
    STARBUCKS_EXPERIENCES_RESERVE_LATER: `Prenota per più tardi`,
    STARBUCKS_EXPERIENCES_BACK: `Torna alle esperienze`,
    STARBUCKS_WAYFINDER_CARD_EXPERIENCE_BUTTON: `Maggiori informazioni`,
    STARBUCKS_WAYFINDER_CARD_MENU_BUTTON: `Vai al menu`,
    STARBUCKS_WAYFINDER_KIOSK_LABEL_FIND: `Dove mi trovo?`,
    STARBUCKS_WAYFINDER_KIOSK_LABEL: `Si trova qui`,
    STARBUCKS_WAYFINDER_BATHROOMS_LABEL: `Servizi igienici`,
    STARBUCKS_WAYFINDER_OPEN_SEATING_LABEL: `Posti liberi`,
    STARBUCKS_WAYFINDER_HOTSPOTS_LABEL: `Trova un luogo`,
    STARBUCKS_WAYFINDER_DIRECTIONS_TITLE: `Trascini con il dito per esplorare lo spazio.`,
    STARBUCKS_WAYFINDER_DIRECTIONS_SUBTITLE: `Tocchi un luogo evidenziato per saperne di più.`,
    STARBUCKS_COFFEE_FINDER_QUESTION_1_TITLE: `Spirito d'avventura`,
    STARBUCKS_COFFEE_FINDER_QUESTION_1_SUBTITLE: `Quanto le piace avventuroso il suo caffè?`,
    STARBUCKS_COFFEE_FINDER_QUESTION_2_TITLE: `Sapori preferiti`,
    STARBUCKS_COFFEE_FINDER_QUESTION_2_SUBTITLE: `Quando pensa al suo caffè, quali sapori le sembrano più deliziosi?`,
    STARBUCKS_COFFEE_FINDER_QUESTION_3_TITLE: `Intensità`,
    STARBUCKS_COFFEE_FINDER_QUESTION_3_SUBTITLE: `Quanto le piace intenso il suo caffè?`,
    STARBUCKS_COFFEE_FINDER_QUESTION_4_TITLE: `Ordine di caffè preferito`,
    STARBUCKS_COFFEE_FINDER_QUESTION_4_SUBTITLE: `Come ordina di solito il suo caffè?`,
    STARBUCKS_COFFEE_FINDER_QUESTION_EDIT: `Tocchi per modificare`,
    STARBUCKS_COFFEE_FINDER_QUESTION_CONFIRM: `Confermi la sua selezione`,
    STARBUCKS_COFFEE_FINDER_QUESTION_RESTART: `Ricomincia`,
    STARBUCKS_COFFEE_FINDER_ANSWER_TITLE: `Sembra che le piacerebbe...`,
    STARBUCKS_COFFEE_FINDER_ANSWER_SUBTITLE: `Acquisti solo i chicchi, oppure le consigliamo la bevanda qui sotto con questo chicco:`,
    STARBUCKS_COFFEE_FINDER_ANSWER_GO_TO_MENU: `Vedi il menu completo`,
    STARBUCKS_COFFEE_FINDER_ANSWER_RESTART: `Ricomincia`,
    STARBUCKS_VIEW_WAYFINDER: `Esplora`,
    STARBUCKS_VIEW_COFFEE_FINDER: `Restringi le mie opzioni`,
    STARBUCKS_VIEW_EXPERIENCES: `Vedi le esperienze`,
    'cover.session.timeout': `Qualcosa è andato storto. Riprovi.`,
    'cover.reduced-height.button': `Inizia a ordinare`,
    'cover.loyalty.title': `Benvenuto`,
    'cover.five-guys.documents': ``,
    'cover.five-guys.allergen-nutrition': ``,
    'cover.five-guys.ingredients': ``,
    'cover.five-guys.storm-document-instructions': ``,
    'cover.loyalty.login': `Accedi con il programma fedeltà`,
    'cover.loyalty.guest': `Continua come ospite`,
    'guest-identifier.button.quit': `Esci`,
    'guest-identifier.button.skip': `Salta`,
    'guest-identifier.button.back': `Indietro`,
    'guest-identifier.button.next': `Continua`,
    'guest-identifier.button.submit.cover': `Continua`,
    'guest-identifier.button.submit.edit': `Continua`,
    'guest-identifier.button.submit.checkout': `Continua`,
    'guest-identifier.phone.tos.button-back': `Indietro`,
    'guest-identifier.phone.tos.title': `Termini di servizio`,
    'guest-identifier.phone.tos.link': `Termini di servizio per il numero di telefono`,
    'guest-identifier.phone.title': ``,
    'guest-identifier.table.instructions.table-number': ``,
    'guest-identifier.table.instructions.tracker-number': ``,
    'guest-identifier.name.loyalty-title': `Acceda con il suo account fedeltà`,
    'guest-identifier.name.loyalty-button': `Accedi con il programma fedeltà`,
    'guest-identifier.name.loyalty-separator': `o`,
    'guest-identifier.name.loyalty-error-title': `Ops! Nessun nome trovato`,
    'guest-identifier.name.loyalty-error-description': `Spiacenti, non siamo riusciti a trovare un nome associato all'account. Inserisca il suo nome qui sotto`,
    'inactivity-timer.button.continue': `Sì, mi serve più tempo`,
    'inactivity-timer.button.exit': `No, ho finito`,
    'item-card.add.with-quantity': `Aggiungi ({{$1: quantity}})`,
    'image.scan.default.alt': `Scansioni il suo codice a barre o codice QR`,
    'loyalty.view_coupons': `Vedi coupon`,
    'loyalty.add_coupons': `Aggiungi coupon`,
    'loyalty.label.manual_redemption': `Codice di riscatto`,
    'loyalty.label.manual_redemption_instructions': `Inserisca il suo codice di riscatto per riscattare il suo premio`,
    'loyalty.label.welcome.new-user': `Ciao {{$1: user}}! Ora ha un account fedeltà`,
    'loyalty.reward_label.payment_unapplied': `Applica il pagamento alla carta registrata`,
    'loyalty.reward_label.redeemable_unredeemed': `Riscatta usando {{$1: points}} punti`,
    'loyalty.reward_label.payment_at_checkout': `Il pagamento può essere applicato al momento del pagamento.`,
    'loyalty.reward_group_label.payment': `Premi di pagamento`,
    'loyalty.rewards.payment-reward.name': `Paga con il saldo`,
    'loyalty.rewards.payment-reward.name-with-amount': `Paga con il saldo ({{$1: amount}})`,
    'loyalty.rewards.payment-reward.description': `Il suo saldo attuale`,
    'loyalty.rewards.card-on-file-payment.description': `Il pagamento verrà addebitato sulla sua carta registrata.`,
    'loyalty.redemption_auth.back_to_rewards': `Torna ai premi`,
    'loyalty.redemption_auth.subtitle': `Scansioni il suo codice a barre di riscatto per riscattare il suo premio`,
    'loyalty.redemption_auth.submit': `Riscatta premio`,
    'loyalty.signup.header': ``,
    'loyalty.signup.email-already-exists': ``,
    'loyalty.signup.email-and-sms-consent': ``,
    'loyalty.signup.enter-your-email-address': ``,
    'loyalty.signup.enter-your-name': `Inserisca il suo nome`,
    'loyalty.signup.enter-your-phone-number': `(555) 555-5555`,
    'loyalty.signup.consent-required': `Accetti i termini e le condizioni per continuare.`,
    'loyalty.checkout-signup.header': `Ultima occasione per registrarsi e guadagnare premi su questo ordine!`,
    'loyalty.checkout-signup.skip': `Salta e procedi al pagamento`,
    'loyalty.checkout-signup.success.new-account.title': `Nuovo account creato`,
    'loyalty.checkout-signup.success.new-account.description': `Grazie per essersi iscritto, guadagnerà premi su questo ordine!`,
    'loyalty.checkout-signup.success.existing-account.title': `L'account esiste già`,
    'loyalty.checkout-signup.success.existing-account.description': `Si è già registrato in precedenza con questo numero. Ora ha effettuato l'accesso.`,
    'loyalty.checkout-signup.error.title': `Errore nella creazione dell'account`,
    'loyalty.checkout-signup.error.description': `Qualcosa è andato storto durante la creazione dell'account`,
    'loyalty.checkout-signup.error.skip': `Salta e procedi al pagamento`,
    'loyalty.checkout-signup.error.try-again': `Riprova`,
    'menu.item.reset': `Reimposta articolo`,
    'menu.mod-group.quick-select': `Selezione rapida`,
    'menu.mod-group.quick-select-active': `Selezionato`,
    'menu.mod-group.quick-select-clear': ``,
    'menu.page.scanner.initial.title': `Scansioni gli articoli per iniziare a ordinare`,
    'menu.page.scanner.scanned.title': `Articoli del carrello`,
    'menu.scanned-item-added-dialog.button.go-to-scanner-page': `Vedi articoli scansionati`,
    'order-history.button.add-to-order': `Aggiungi articoli disponibili ({{$1: number}})`,
    'order-history.title': `Cronologia ordini`,
    'order-history.subtitle': `Tutti i suoi ordini precedenti appariranno qui. Interagisca con gli articoli per visualizzarli o aggiungerli al suo ordine attuale. Può aggiungere tutti gli articoli di un ordine con un solo tocco.`,
    'order-history.next-page': `Avanti`,
    'order-history.previous-page': `Indietro`,
    'order-history.screen.close': `Chiudi`,
    'order-history.screen.error.title': `Qualcosa è andato storto`,
    'order-history.screen.error.subtitle': `Impossibile caricare la cronologia degli ordini. Riprovi più tardi.`,
    'order-history.screen.error.button.back': `Indietro`,
    'order-history.screen.error.button.retry': `Riprova`,
    'order-history.screen.no-orders': `Nessun ordine precedente trovato. Quando effettuerà un ordine, torni qui per visualizzarlo.`,
    'order-history.screen.order-has-quick-add-uneligible-items': `Alcuni articoli di questo ordine non sono disponibili per il riordino rapido. Aggiunga gli articoli toccandoli singolarmente.`,
    'order-history.section.button.view-all': `Vedi altri miei ordini`,
    'order-history.topbar.button.back': `Indietro`,
    'loyalty.unapplicable_rewards_warning_title': `Premi non applicabili`,
    'loyalty.unapplicable_rewards_warning_description': `Per riscattare il premio selezionato, aggiunga gli articoli corrispondenti al suo carrello. Il premio e lo sconto verranno applicati al momento del pagamento.`,
    'loyalty.unapplicable_rewards_warning_confirm': `Applica`,
    'loyalty.discard_reward_changes.title': ``,
    'loyalty.discard_reward_changes.description': ``,
    'loyalty.discard_reward_changes.keep_editing': ``,
    'loyalty.discard_reward_changes.discard': ``,
    'loyalty.rewards.terms_button_label': ``,
    'loyalty.rewards.terms_dialog.apply': ``,
    'loyalty.rewards.terms_dialog.remove': ``,
    'loyalty.rewards.terms_dialog.back': ``,
    'loyalty.reward_ineligible.title': ``,
    'loyalty.reward_ineligible.title_generic': ``,
    'loyalty.reward_ineligible.title_plural': ``,
    'loyalty.reward_ineligible.description': ``,
    'loyalty.reward_ineligible.description_plural': ``,
    'loyalty.reward_ineligible.back_to_menu': ``,
    'loyalty.reward_ineligible.continue': ``,
    'loyalty.reward_ineligible.continue_plural': ``,
    'loyalty.auth_method.manual_redemption': `Inserimento manuale`,
    'loyalty.button.menu.authed': `Premi`,
    'loyalty.button.menu.unauthed': `Premi`,
    'loyalty.button.checkout.authed': `Premi`,
    'loyalty.button.checkout.unauthed': `Premi`,
    'loyalty.error.reward_failed_to_apply': `Impossibile applicare il premio. Riprovi.`,
    'loyalty.login.pin.label': ``,
    'loyalty.login.pin.error-required': ``,
    'loyalty.login-options.button.skip.menu': `Salta e continua al menu`,
    'loyalty.login-options.button.skip.checkout': `Salta e continua al pagamento`,
    'loyalty.login-options.button.skip.dining-option-collection': `Salta e continua al pagamento`,
    'loyalty.login-options.title': `Scelga un'opzione per accedere o continui come ospite`,
    'loyalty.login-options.subtitle': `Può sempre accedere più tardi`,
    'loyalty.login-options.signup.link': `Non ha un account? Si registri`,
    'loyalty.login-options.barcode.title': `Scansiona codice a barre`,
    'loyalty.login-options.barcode.subtitle': `Scansioni il suo codice a barre per accedere`,
    'loyalty.login-options.email-phone-number.title': `Email e numero di telefono`,
    'loyalty.login-options.email-phone-number.subtitle': `Inserisca la sua email e il suo numero di telefono per accedere`,
    'loyalty.login-options.email-password.title': `Email e password`,
    'loyalty.login-options.email-password.subtitle': `Inserisca la sua email e la sua password per accedere`,
    'loyalty.login-options.username-password.title': `Nome utente e password`,
    'loyalty.login-options.username-password.subtitle': `Inserisca il suo nome utente e la sua password per accedere`,
    'loyalty.login-options.phone-number.placeholder': `(555) 555-5555`,
    'loyalty.login-options.phone-number.title': `Numero di telefono`,
    'loyalty.login-options.phone-number.subtitle': `Inserisca il suo numero di telefono per accedere`,
    'loyalty.login-options.card-number.title': `Numero di carta`,
    'loyalty.login-options.card-number.subtitle': `Inserisca il suo numero di carta per accedere`,
    'loyalty.login-options.email.title': `Email`,
    'loyalty.login-options.email.subtitle': `Inserisca la sua email per accedere`,
    'loyalty.login-options.or': `OPPURE`,
    'loyalty.login-options.popup.close': `Chiudi`,
    'loyalty.error.or': `OPPURE`,
    'loyalty.login-error.saved-form': `Le informazioni che ha inviato:`,
    'loyalty.login-error.try-again.button': `Riprova`,
    'loyalty.otp.enter-code.title': `Inserisca il codice che le abbiamo inviato`,
    'loyalty.otp.sent-to.email': `Abbiamo inviato un codice via email a {{$1: masked email}}`,
    'loyalty.otp.sent-to.sms': `Abbiamo inviato un codice via SMS a {{$1: masked phone number}}`,
    'loyalty.otp.verify': `Verifica`,
    'loyalty.otp.resend': `Invia di nuovo il codice`,
    'loyalty.otp.code.error.invalid': `Quel codice non è corretto. Riprovi.`,
    'loyalty.otp.send-error.message': `Non siamo riusciti ad abbinare esattamente un account a queste informazioni. Le verifichi e riprovi.`,
    'loyalty.login.fallback.phone-number.button': `Usa invece il numero di telefono`,
    'loyalty.login.fallback.barcode.button': `Scansiona invece un codice a barre o codice QR`,
    'loyalty.login.fallback.card-number.button': `Usa invece il numero di carta`,
    'loyalty.login.fallback.email.button': `Usa invece l'email`,
    'loyalty.login.fallback.email-phone-number.button': `Usa invece l'email e il numero di telefono`,
    'loyalty.login.fallback.email-password.button': `Usa invece l'email e la password`,
    'loyalty.login.fallback.username-password.button': `Usa invece il nome utente e la password`,
    'loyalty.login.auth-method.phone-number.title': `Numero di telefono`,
    'loyalty.login.auth-method.barcode.title': `Scansiona codice a barre o codice QR`,
    'loyalty.login.auth-method.card-number.title': `Numero di carta`,
    'loyalty.login.auth-method.email.title': `Email`,
    'loyalty.login.auth-method.email-phone-number.title': `Email e numero di telefono`,
    'loyalty.login.auth-method.email-password.title': `Email e password`,
    'loyalty.login.auth-method.username-password.title': `Nome utente e password`,
    'vitrine.error.order_validation_failed': `Impossibile convalidare l'ordine. Riprovi.`,
    'vitrine.error.handshake_failed': `Impossibile connettersi al chiosco. Contatti un membro del personale per assistenza.`,
    'vitrine.error.request_timeout': `Impossibile completare la richiesta. Riprovi.`,
    'vitrine.error.request_aborted': `Impossibile completare la richiesta. Riprovi.`,
    'vitrine.error.analytics_send_error': `Impossibile inviare i dati analitici. Riprovi.`,
    'vitrine.error.garcon_incompatible_build': `Impossibile connettersi al chiosco. Contatti un membro del personale per assistenza.`,
    'vitrine.error.loyalty-login-no-matching-user-title': `Impossibile trovare il suo account`,
    'vitrine.error.loyalty-login-no-matching-user-message': `Non abbiamo trovato un utente con le informazioni fornite.`,
    'vitrine.error.loyalty_not_enough_points': `Il suo account non ha punti sufficienti per riscattare i premi selezionati.`,
    'vitrine.error.order_total_above_max': `Il totale dell'ordine ha superato il massimo consentito. Si rivolga a un membro del personale.`,
    'vitrine.error.empty_menu': `Il menu che ha selezionato è attualmente vuoto. Provi un'altra opzione di ordinazione.`,
    'maitred.error.integration_bad_config': `Sembra esserci un problema con la configurazione del chiosco. Si rivolga a un membro del personale.`,
    'checkout.done.expo_receipt.error': `Impossibile stampare la ricevuta. Riprovi.`,
    'checkout.done.expo_receipt.success': `Ricevuta inviata! Chieda assistenza a un membro del team.`,
    'checkout.done.print-receipt.out-of-paper': `La stampante è senza carta. Si rivolga a un membro del team per la sua ricevuta.`,
    'refunder.viewing-results.button.cancel': `Annulla`,
    'refunder.viewing-results.button.refund-all': `Rimborsa tutto`,
    'refunder.viewing-results.button.view-transaction': `Visualizza transazioni`,
    'refunder.viewing-results.button.done': `Fatto`,
    'refunder.viewing-results.button.back': `Indietro`,
    'refunder.viewing-results.button.search': `Cerca ordine`,
    'refunder.viewing-results.refund-order.error-print-receipt': `L'ordine è stato rimborsato con successo, ma non siamo riusciti a stampare la ricevuta. Provi a stampare di nuovo.`,
    'refunder.viewing-results.refund-order.success': `L'ordine è stato rimborsato con successo.`,
    'refunder.viewing-results.refund-order.error': `Impossibile rimborsare l'ordine. Riprovi.`,
    'refunder.viewing-results.order.refunded': `Ordine rimborsato`,
    'refunder.viewing-results.order.total': `Totale ordine`,
    'refunder.search-form.button.back': `Indietro`,
    'refunder.search-form.button.search': `Cerca`,
    'refunder.viewing-order.title': `Tutte le transazioni per l'ordine #{{$1: order number}}`,
    'refunder.viewing-order.subtitle': `Selezioni la transazione che desidera rimborsare.`,
    'refunder.viewing-order.button.cancel': `Annulla`,
    'refunder.viewing-order.button.refund': `Rimborsa`,
    'refunder.viewing-order.button.refund-partial': `Rimborso parziale`,
    'refunder.viewing-order.button.retry': `Riprova`,
    'refunder.viewing-order.button.done': `Fatto`,
    'refunder.viewing-order.button.back': `Indietro`,
    'refunder.viewing-order.refund-transaction.error': `Impossibile rimborsare la transazione. Riprovi.`,
    'refunder.viewing-order.refund-transaction.success': `Transazione rimborsata con successo.`,
    'refunder.viewing-order.refund-transaction.error-print-receipt': `La transazione è stata rimborsata con successo, ma non siamo riusciti a stampare la ricevuta. Provi a stampare di nuovo.`,
    'refunder.viewing-order.transaction.total': `Totale`,
    'refunder.viewing-order.transaction.refunded': `Rimborsato`,
    'refunder.viewing-order.error.title': `Errore`,
    'refunder.viewing-order.error.message': `Impossibile caricare l'ordine. Riprovi.`,
    'refunder.viewing-order.error.button.retry': `Riprova`,
    'refunder.viewing-order.error.button.back': `Indietro`,
    'refunder.partial-transaction-refund.error.amount-too-high': `L'importo è troppo alto.`,
    'refunder.partial-transaction-refund.error.amount-too-low': `L'importo è troppo basso.`,
    'refunder.partial-transaction-refund.error.amount-invalid': `L'importo non è valido.`,
    'refunder.partial-transaction-refund.error.amount-required': `L'importo è obbligatorio.`,
    'refunder.partial-transaction-refund.error': `Si è verificato un problema durante l'elaborazione del rimborso. Riprovi.`,
    'refunder.partial-transaction-refund.button.submit': `Invia rimborso parziale`,
    'refunder.partial-transaction-refund.button.back': `Indietro`,
    'refunder.partial-transaction-refund.title': `Rimborso parziale della transazione`,
    'refunder.partial-transaction-refund.hint': `Inserisca l'importo che desidera rimborsare. L'importo massimo è {{$1: amount}}`,
    'refunder.partial-transaction-refund.label': `Importo`,
    'refunder.partial-transaction-refund.placeholder': `0.00`,
    'checkout.cart.alcohol-verification.age-requirement': `21+`,
    'checkout.cart.alcohol-requires-food.notice': ``,
    'checkout.cart.alcohol-requires-food.title': ``,
    'checkout.cart.alcohol-requires-food.description': ``,
    'checkout.cart.group-ordering.actions.change-recipient': `Modifica destinatario`,
    'checkout.cart.guest-ordering.recipient-assignment-dialog.title': `Assegna articolo a`,
    'checkout.cart.guest-ordering.recipient-assignment-dialog.cancel': `Annulla`,
    'checkout.cart.guest-ordering.recipient-assignment-dialog.add-new': `Aggiungi nuovo`,
    'checkout.cart.guest-ordering.recipient-assignment-dialog.reassign': `Riassegna`,
    'checkout.cart.guest-ordering.recipient-assignment-dialog.who-is-this-for': `Per chi è questo articolo?`,
    'checkout.cart.guest-ordering.recipient-assignment-dialog.assign-to-guest': `Assegna a questo ospite`,
    'checkout.cart.starbucks-stars': `Articolo da {{$1: amount}} ★`,
    'checkout.cart.mod-group-heading': `{{$1: mod group name}}:`,
    'checkout.cart.upsize.title': ``,
    'checkout.cart.upsize.label': ``,
    'menu.nav.starbucks.menu': `Menu principale`,
    'menu.nav.starbucks.experiences': `Esperienze`,
    'menu.nav.starbucks.wayfinder': `Esplora il locale`,
    'menu.secret-menu.access-code.title': `Inserisci codice di accesso`,
    'menu.secret-menu.access-code.button.back': `Indietro`,
    'menu.secret-menu.access-code.button.submit': `Invia`,
    'menu.secret-menu.access-code.error': `Codice di accesso non valido`,
    'menu.secret-menu.access-code.success': `Codice di accesso accettato`,
    'menu.toast.added-to-cart': `Aggiunto al carrello`,
    'menu.toast.combo-savings': `Risparmio con combo!`,
    'menu.toast.discount-applied': `Sconto applicato!`,
    'menu.exit-verification.title': `È richiesta la verifica del manager`,
    'menu.exit-verification.description': `È richiesto un codice di accesso dipendente per uscire. Chieda assistenza a un membro del team.`,
    'menu-item.starbucks-stars': `{{$1: amount}} ★`,
    'menu-item.product-information.title': ``,
    'menu-item.product-information.open': ``,
    'menu-item.product-information.tab.product-info': ``,
    'menu-item.product-information.tab.nutrition': ``,
    'menu-item.product-information.tab.allergens': ``,
    'menu-item.product-information.nutrition.option': ``,
    'menu-item.product-information.empty': ``,
    'menu-item.scale.title': `Posizioni il suo articolo sulla bilancia.`,
    'menu-item.scale.weight': `{{$1: weight}} {{$2: unit}}`,
    'menu-item.scale.weighs': `Pesa`,
    'menu-item.scale.price-per-unit': `{{$1: price}} per {{$2: unit}}`,
    'menu-item.scale.price': `Prezzo`,
    'menu-item.scale.instructions': `Usi la bilancia per pesare il suo articolo. Per azzerare, tocchi il pulsante indicato sulla bilancia.`,
    'menu-item.scale.weight-per-unit': `{{$1: weight}} {{$2: unit}}`,
    'menu-item.scale.reading-weight': `Pesatura in corso...`,
    'menu-item.scale.error-reading-weight': `Errore nella lettura del peso. Riprovi.`,
    'menu-item.scale.error-no-weight': `Pesi il suo articolo se desidera aggiungerlo al suo ordine.`,
    'menu-item.scale.no-scale': `Nessuna bilancia rilevata. Si rivolga a un membro del personale.`,
    'also-consider.title': `Potrebbe interessarle anche...`,
    'also-consider.back-to-item': `Torna all'articolo`,
    'also-consider.add-to-order': `Aggiungi all'ordine`,
    'also-consider.skip-add-on': `Salta aggiunta`,
    'menu-item.assorted.title': `Componga il suo assortimento`,
    'menu-item.assorted.count': `{{$1: count}} di {{$2: total}} selezionati`,
    'menu-item.row-size-mod.option.none': `Nessuno`,
    'menu-item.upsize.prompt.title': `Vuoi un formato più grande?`,
    'menu-item.upsize.comparison.title': ``,
    'menu-item.upsize.comparison.accept': ``,
    'menu-item.upsize.comparison.speech': ``,
    'menu-item.upsize.comparison.price-difference': ``,
    'menu-item.upsize.prompt.accept': `Sì, scegli {{$1: size name}}`,
    'menu-item.upsize.prompt.decline': `No, grazie`,
    'menu-item.upsize.nudge': `Scegli {{$1: size name}}`,
    'menu-item.upsize.selection-loss.title': ``,
    'menu-item.upsize.selection-loss.description': ``,
    'menu-item.upsize.selection-loss.confirm': ``,
    'menu-item.upsize.selection-loss.cancel': ``,
    'menu-item.high-sugar-warning.description': `Avvertenza: questa icona indica che il contenuto di zuccheri aggiunti di questo articolo è pari o superiore al limite giornaliero totale raccomandato di zuccheri aggiunti per una dieta da 2.000 calorie (50 g). Consumare o bere grandi quantità di zuccheri aggiunti nel tempo può aumentare il rischio di diabete di tipo 2, aumento di peso e carie dentale.`,
    'menu-item.high-sodium-warning.description': `Avvertenza: questa icona indica che il contenuto di sodio (sale) di questo articolo è superiore al limite giornaliero totale raccomandato (2.300 mg). Un elevato consumo di sodio può aumentare la pressione sanguigna e il rischio di malattie cardiache e ictus.`,
    'menu-item.group-ordering.items-for': `Ordine di gruppo - Articoli per:`,
    'menu-item.group-ordering.prompt.title': `Ordina in gruppo?`,
    'menu-item.group-ordering.prompt.description': `L'opzione di ordine di gruppo le chiederà a quale membro del suo gruppo è destinato ciascun articolo. Tocchi "Sì" per attivare l'ordine di gruppo. Tocchi "No" se desidera continuare con questa opzione.`,
    'menu-item.group-ordering.prompt.button.accept': `Sì, ordine di gruppo`,
    'menu-item.group-ordering.prompt.button.decline': `No, grazie`,
    'menu-item.group-ordering.add-recipient': `Aggiungi nuovo`,
    'menu-item.group-ordering.add-recipient-name.dialog.title': `Aggiungi nuovo destinatario`,
    'menu-item.group-ordering.add-recipient-name.dialog.placeholder': `Inserisca il nome del destinatario`,
    'menu-item.group-ordering.add-recipient-name.dialog.button.submit': `Assegna all'ospite`,
    'menu-item.group-ordering.add-recipient-name.dialog.button.cancel': `Annulla`,
    'menu-item.group-ordering.recipient-picker.title': `Per chi è?`,
    'menu-item.group-ordering.recipient-picker.add-new': `Aggiungi nuovo`,
    'menu-item.nested-mod-groups.edit': `Modifica`,
    'menu-item.nested-mod-groups.popup.done': `Fatto`,
    'menu-item.nested-mod-groups.popup.cancel': `Annulla`,
    'menu-item.nested-mod-groups.popup.back': `Indietro`,
    'menu-item.nested-mod-groups.popup.next': `Avanti`,
    'checkout.cart.remove-item-verification.title': `È richiesta la verifica del manager`,
    'checkout.cart.remove-item-verification.description': `È richiesto un codice di accesso dipendente per rimuovere questo articolo dal carrello. Chieda assistenza a un membro del team.`,
    'checkout.cart.confirm-remove-item.title': `Rimuovere l'articolo?`,
    'checkout.cart.confirm-remove-item.description': `È sicuro di voler rimuovere {{$1: item name}} dal suo carrello?`,
    'checkout.cart.confirm-remove-item.cancel': `Annulla`,
    'checkout.cart.confirm-remove-item.confirm': `Rimuovi`,
    'checkout.cart.pre-checkout-recommendations.title': `Completi il suo ordine`,
    'checkout.cart.pre-checkout-recommendations.continue-button': `Continua`,
    'checkout.cart.pre-checkout-recommendations.back-button': `Indietro`,
    'checkout.cart.item-86d.title.items': `Alcuni articoli non sono più disponibili`,
    'checkout.cart.item-86d.title.mods': `Alcune modifiche non sono più disponibili`,
    'checkout.cart.item-86d.title.mixed': `Alcuni articoli e modifiche non sono più disponibili`,
    'checkout.cart.item-86d.description.items': `I seguenti articoli sono stati rimossi dal suo carrello:`,
    'checkout.cart.item-86d.description.mods': `Le seguenti modifiche sono state rimosse dai suoi articoli:`,
    'checkout.cart.item-86d.description.mixed': `I seguenti elementi non sono più disponibili e sono stati rimossi:`,
    'checkout.cart.item-86d.entity.menu-item': `{{$1: item name}}`,
    'checkout.cart.item-86d.entity.price-option': `{{$1: item name}} — {{$2: price option name}}`,
    'checkout.cart.item-86d.entity.mod': `{{$1: mod name}} (in {{$2: item name}})`,
    'checkout.cart.item-86d.edit-item-button': `Modifica`,
    'checkout.payment-options.tip.invalid-tip-amount': `Spiacenti, non può applicare una mancia superiore al totale dell'ordine. Inserisca un valore di mancia inferiore al subtotale dell'ordine meno eventuali sconti.`,
    'checkout.payment-options.name.title': `Ciao, {{$1: name}}`,
    'checkout.payment-options.gift-cards.prompt.title': `Selezioni un metodo con carta regalo`,
    'checkout.payment-options.gift-cards.prompt.default-option': `Carta regalo`,
    'checkout.payment-options.pay-with-cash-machine.label': `Tocchi per pagare con la macchina del contante`,
    'checkout.payment-options.pay-with-cash-machine.button': `Contanti`,
    'checkout.payment-options.donation.or': `OPPURE`,
    'checkout.payment-options.service-charge.info-message': ``,
    'checkout.payment-options.service-charge.info-label': `Informazioni sul costo del servizio`,
    'checkout.payment-options.credit-card.button.zero-balance': `Invia ordine`,
    'checkout.payment-options.inline-loyalty.view-all': `Visualizza tutti i premi`,
    'checkout.payment-options.inline-loyalty.apply': `Applica premi`,
    'checkout.payment-options.inline-loyalty.greeting': `Ciao, {{$1: name}}!`,
    'checkout.payment-options.inline-loyalty.star-balance': `Saldo stelle: {{$1: stars}}★`,
    'checkout.payment-options.inline-loyalty.celebration.title': `Buon compleanno!`,
    'checkout.payment-options.inline-loyalty.celebration.title-with-name': `Buon compleanno, {{$1: name}}!`,
    'checkout.payment-options.inline-loyalty.celebration.subtitle': `Si goda il suo regalo!`,
    'checkout.payment-options.inline-loyalty.error.title': `Impossibile applicare i premi`,
    'checkout.payment-options.inline-loyalty.error.message': `Si è verificato un errore durante l'applicazione dei suoi premi. Riprovi.`,
    'loyalty.starbucks.header.redeemable-stars': `Stelle riscattabili`,
    'loyalty.starbucks.header.stars-expiring': `{{$1: stars}}★ scadono il {{$2: date}}`,
    'loyalty.starbucks.header.stars-no-expiry': `Le sue stelle non scadranno`,
    'loyalty.starbucks.progress.next-status-by-date': `Guadagni {{$1: stars}}★ entro il {{$2: date}} per raggiungere il livello {{$3: level}}`,
    'loyalty.starbucks.progress.next-status': `Guadagni {{$1: stars}}★ per raggiungere il livello {{$2: level}}`,
    'loyalty.starbucks.progress.maintain-status-by-date': `Guadagni {{$1: stars}}★ entro il {{$2: date}} per estendere il suo livello {{$3: level}} per un altro anno`,
    'loyalty.starbucks.progress.maintain-status': `Guadagni {{$1: stars}}★ per estendere il suo livello {{$2: level}} per un altro anno`,
    'loyalty.starbucks.progress.extended': `Esteso per un altro anno`,
    'loyalty.starbucks.progress.annual-earned': `Guadagnate quest'anno`,
    'loyalty.starbucks.progress.status-target': `Livello {{$1: level}}`,
    'loyalty.starbucks.progress.to-extend': `per estendere`,
    'loyalty.starbucks.birthday.title': `Buon compleanno, {{$1: name}}!`,
    'loyalty.starbucks.birthday.title-no-name': `Buon compleanno!`,
    'loyalty.starbucks.birthday.redeem': `Riscatti il suo coupon di compleanno!`,
    'loyalty.starbucks.birthday.description': `Si goda la sua bevanda o dolcetto preferito, offerto da noi. Lo riscatti al pagamento o lo comunichi al suo barista al momento dell'ordine.`,
    'loyalty.starbucks.birthday.valid-until': `Valido fino al {{$1: date}}`,
    'loyalty.starbucks.member-since': `Membro dal {{$1: year}}`,
    'loyalty.starbucks.member-since.subtitle': `Grazie per essere un membro fedele di Starbucks Rewards.`,
    'checkout.paying.starbucks.title': `Scansioni ora il codice QR nella sua app Starbucks`,
    'checkout.paying.starbucks.subtitle': `Si assicuri di avere pronta la funzione Scan to Pay nella sua app Starbucks per completare il suo ordine.`,
    'checkout.paying.starbucks.cancel-button': `Annulla`,
    'checkout.paying.error.card-not-accepted': ``,
    'checkout.paying.error.loyalty-payment': `Spiacenti, non siamo riusciti a elaborare il suo pagamento. Riprovi.`,
    'checkout.paying.error.pos.print': `Continua e stampa ricevuta`,
    'checkout.paying.error.table-tracker.print': `Continua e stampa ricevuta`,
    'checkout.paying.error.table-tracker.title': `Ops! Non siamo riusciti a ottenere il suo cercapersone.`,
    'checkout.paying.error.table-tracker.instructions': `Il suo ordine è andato a buon fine, ma si è verificato un errore nell'erogazione del localizzatore da tavolo per tracciare il suo ordine. Proceda al passaggio successivo per ricevere la sua ricevuta.`,
    'checkout.paying.error.title': `Ops!`,
    'checkout.paying.sending-table-tracker-request.title': `Erogazione del cercapersone`,
    'checkout.paying.sending-table-tracker-request.subtitle': `Attenda mentre eroghiamo il suo localizzatore da tavolo.`,
    'checkout.paying.cash-machine.pinging.title': `Verifica della macchina del contante`,
    'checkout.paying.cash-machine.pinging.subtitle': `Attenda mentre verifichiamo se la macchina del contante è disponibile.`,
    'checkout.paying.cash-machine.awaiting.title': `Macchina del contante in uso`,
    'checkout.paying.cash-machine.awaiting.subtitle': `Attenda finché la macchina del contante non sia disponibile.`,
    'checkout.paying.cash-machine.awaiting.cancel-button': `Annulla`,
    'checkout.paying.cash-machine.receiving.title': `Macchina del contante pronta`,
    'checkout.paying.cash-machine.receiving.subtitle': `Inserisca il suo pagamento nella macchina del contante.`,
    'checkout.paying.cash-machine.receiving.cancel-button': `Annulla`,
    'checkout.paying.cash-machine.receiving.cancel-refund-button': `Annulla e rimborsa il pagamento`,
    'checkout.paying.cash-machine.receiving.partial-button': `Paga il resto in un altro modo`,
    'checkout.paying.cash-machine.receiving.amount': `{{$1: amount}} rimanente`,
    'checkout.paying.cash-machine.receiving.take-change-prompt': `Prenda tutte le banconote e le monete dalla macchina del contante.`,
    'checkout.paying.cash-machine.cancelling.title': `Annullamento del pagamento nella macchina del contante`,
    'checkout.paying.cash-machine.cancelling.subtitle': `Prenda tutte le banconote e le monete dalla macchina del contante.`,
    'checkout.paying.cash-machine.cancelling.error.title': `Errore nell'annullamento del pagamento nella macchina del contante`,
    'checkout.paying.cash-machine.cancelling.error.subtitle': `Non è stato possibile annullare il suo pagamento. Chieda aiuto a un membro del personale.`,
    'checkout.paying.cash-machine.cancelling.error.print': `Continua e stampa ricevuta`,
    'checkout.paying.cash-machine.cancelling.insufficient-change.title': `Resto insufficiente`,
    'checkout.paying.cash-machine.cancelling.insufficient-change.subtitle': `La macchina del contante non è riuscita a darle il resto per il suo pagamento, quindi abbiamo rimborsato il suo pagamento.`,
    'checkout.paying.cash-machine.cancelling.insufficient-change.try-again-button': `Riprova`,
    'checkout.paying.cash-machine.cancelling.insufficient-change.back-button': `Indietro`,
    'checkout.paying.cash-machine.error.message': `La macchina del contante non è riuscita a elaborare il suo pagamento. Riprovi.`,
    'checkout.done.details.guest-name': `Nome`,
    'checkout.done.details.table-number': `Numero del tavolo`,
    'checkout.done.details.tracker-number': `Numero del localizzatore`,
    'checkout.done.details.order-number': `Numero dell'ordine`,
    'checkout.done.error.table-tracker.instructions': `Si è verificato un errore nel recupero del suo cercapersone. Il suo ordine è stato elaborato con successo. Chieda aiuto a un dipendente.`,
    'checkout.done.qr-code.error': `Spiacenti, non siamo riusciti a generare un codice QR per la sua ricevuta.`,
    'printer-receipt.stored-value-remaining-balance': `Saldo residuo di {{$1: label}}`,
    'printer-receipt.order-ready-at': ``,
    'printer-receipt.punchh-barcode-header': ``,
    'printer-receipt.refund-receipt-header': ``,
    'order-reconciler.error.dining-option-unavailable': `L'opzione di ristorazione che ha selezionato non è più disponibile. Il suo ordine è stato aggiornato per usare "{{$1: dining option name}}".`,
    'order-reconciler.error.items-unavailable': `Alcuni articoli del suo ordine non sono più disponibili. Il suo ordine è stato aggiornato per rimuovere gli articoli non disponibili. Sono stati rimossi i seguenti articoli: {{$1: item names}}`,
    'page-nav.order-history-item.title': `I suoi ordini`,
    'page-nav.order-history-item.cta': `Visualizza i miei ordini`,
    'print.error.phone-number-label': `Numero di telefono`,
    'print.error.guest-name-label': `Nome`,
    'print.error.table-number-label': `Numero del tavolo`,
    'print.error.tracker-number-label': `Numero del localizzatore`,
    'print.error.order-number-label': `Numero dell'ordine`,
    'debug.untranslated-locale': ``,
};
//# sourceMappingURL=strings.it-it.js.map